// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-docs.js

import React from 'react';

export const ugenCategories = [
  "Analysis",
  "Bufdelays",
  "Buffers",
  "Control",
  "Conversion",
  "Delays",
  "Demand",
  "Dynamics",
  "Envelopes",
  "Fft",
  "Filters",
  "Granular",
  "Info",
  "Inout",
  "Math",
  "Multichannel",
  "Noise",
  "Oscillators",
  "Panning",
  "Physical",
  "Pitchtime",
  "Random",
  "Reverb",
  "Triggers"
];

export const ugenData = {
  "Analysis": [
    {
      "name": "RunningSum",
      "description": "Running sum over a window. Calculates a running sum over the last N samples.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "numsamp",
          "type": "float",
          "default": 40,
          "description": "Number of samples in the running sum window"
        }
      ],
      "outputs": 1,
      "category": "Analysis",
      "functions": [
        "running_sum_ar",
        "running_sum_kr"
      ]
    },
    {
      "name": "RunningMin",
      "description": "Running minimum over a window. Tracks the minimum value over the last N samples.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "numsamp",
          "type": "float",
          "default": 40,
          "description": "Number of samples in the window"
        }
      ],
      "outputs": 1,
      "category": "Analysis",
      "functions": [
        "running_min_ar",
        "running_min_kr"
      ]
    },
    {
      "name": "RunningMax",
      "description": "Running maximum over a window. Tracks the maximum value over the last N samples.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "numsamp",
          "type": "float",
          "default": 40,
          "description": "Number of samples in the window"
        }
      ],
      "outputs": 1,
      "category": "Analysis",
      "functions": [
        "running_max_ar",
        "running_max_kr"
      ]
    },
    {
      "name": "PeakFollower",
      "description": "Peak tracking envelope follower. Follows the peak amplitude of a signal.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "decay",
          "type": "float",
          "default": 0.999,
          "description": "Decay coefficient per sample (0 to 1). Values close to 1 = slower decay"
        }
      ],
      "outputs": 1,
      "category": "Analysis",
      "functions": [
        "peak_follower_ar",
        "peak_follower_kr"
      ]
    },
    {
      "name": "Slope",
      "description": "Measures the rate of change (slope/derivative) of a signal per sample.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        }
      ],
      "outputs": 1,
      "category": "Analysis",
      "functions": [
        "slope_ar",
        "slope_kr"
      ]
    },
    {
      "name": "ZeroCrossing",
      "description": "Zero crossing frequency. Estimates frequency by counting zero crossings.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        }
      ],
      "outputs": 1,
      "category": "Analysis",
      "functions": [
        "zero_crossing_ar",
        "zero_crossing_kr"
      ]
    },
    {
      "name": "Pitch",
      "description": "Pitch tracking and analysis. Autocorrelation-based pitch detector.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to analyze"
        },
        {
          "name": "initFreq",
          "type": "float",
          "default": 440,
          "description": "Initial frequency guess in Hz"
        },
        {
          "name": "minFreq",
          "type": "float",
          "default": 60,
          "description": "Minimum frequency to detect in Hz"
        },
        {
          "name": "maxFreq",
          "type": "float",
          "default": 4000,
          "description": "Maximum frequency to detect in Hz"
        },
        {
          "name": "execFreq",
          "type": "float",
          "default": 100,
          "description": "Analysis rate in Hz"
        },
        {
          "name": "maxBinsPerOctave",
          "type": "float",
          "default": 16,
          "description": "Granularity of pitch detection"
        },
        {
          "name": "median",
          "type": "float",
          "default": 1,
          "description": "Median filter length (0=no filter)"
        },
        {
          "name": "ampThreshold",
          "type": "float",
          "default": 0.01,
          "description": "Amplitude threshold below which frequency = 0"
        },
        {
          "name": "peakThreshold",
          "type": "float",
          "default": 0.5,
          "description": "Peak threshold for autocorrelation (0 to 1)"
        },
        {
          "name": "downSample",
          "type": "float",
          "default": 1,
          "description": "Downsampling factor"
        }
      ],
      "outputs": 2,
      "category": "Analysis",
      "functions": [
        "pitch_kr"
      ]
    }
  ],
  "Bufdelays": [
    {
      "name": "BufDelayN",
      "description": "Buffer-based delay line with no interpolation. Uses a shared buffer for delay storage.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "buf",
          "type": "float",
          "default": 0,
          "description": "Buffer number to use for delay line"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        }
      ],
      "outputs": 1,
      "category": "BufDelays",
      "functions": [
        "buf_delay_n_ar",
        "buf_delay_n_kr"
      ]
    },
    {
      "name": "BufDelayL",
      "description": "Buffer-based delay line with linear interpolation. Uses a shared buffer.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "buf",
          "type": "float",
          "default": 0,
          "description": "Buffer number to use for delay line"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        }
      ],
      "outputs": 1,
      "category": "BufDelays",
      "functions": [
        "buf_delay_l_ar",
        "buf_delay_l_kr"
      ]
    },
    {
      "name": "BufDelayC",
      "description": "Buffer-based delay line with cubic interpolation. Uses a shared buffer for highest quality.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "buf",
          "type": "float",
          "default": 0,
          "description": "Buffer number to use for delay line"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        }
      ],
      "outputs": 1,
      "category": "BufDelays",
      "functions": [
        "buf_delay_c_ar",
        "buf_delay_c_kr"
      ]
    },
    {
      "name": "BufCombN",
      "description": "Buffer-based comb delay with no interpolation. Uses shared buffer for comb filtering.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "buf",
          "type": "float",
          "default": 0,
          "description": "Buffer number to use for delay line"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "BufDelays",
      "functions": [
        "buf_comb_n_ar"
      ]
    },
    {
      "name": "BufCombL",
      "description": "Buffer-based comb delay with linear interpolation. Shared buffer comb filter.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "buf",
          "type": "float",
          "default": 0,
          "description": "Buffer number to use for delay line"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "BufDelays",
      "functions": [
        "buf_comb_l_ar"
      ]
    },
    {
      "name": "BufCombC",
      "description": "Buffer-based comb delay with cubic interpolation. Highest quality shared buffer comb.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "buf",
          "type": "float",
          "default": 0,
          "description": "Buffer number to use for delay line"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "BufDelays",
      "functions": [
        "buf_comb_c_ar"
      ]
    },
    {
      "name": "BufAllpassN",
      "description": "Buffer-based allpass delay with no interpolation. Shared buffer allpass filter.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "buf",
          "type": "float",
          "default": 0,
          "description": "Buffer number to use for delay line"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "BufDelays",
      "functions": [
        "buf_allpass_n_ar"
      ]
    },
    {
      "name": "BufAllpassL",
      "description": "Buffer-based allpass delay with linear interpolation. Shared buffer allpass.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "buf",
          "type": "float",
          "default": 0,
          "description": "Buffer number to use for delay line"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "BufDelays",
      "functions": [
        "buf_allpass_l_ar"
      ]
    },
    {
      "name": "BufAllpassC",
      "description": "Buffer-based allpass delay with cubic interpolation. Highest quality shared buffer allpass.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "buf",
          "type": "float",
          "default": 0,
          "description": "Buffer number to use for delay line"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "BufDelays",
      "functions": [
        "buf_allpass_c_ar"
      ]
    }
  ],
  "Buffers": [
    {
      "name": "PlayBuf",
      "description": "Buffer playback oscillator. Plays back audio from a buffer.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 1,
          "description": "Number of channels in the buffer"
        },
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to play"
        },
        {
          "name": "rate",
          "type": "float",
          "default": 1,
          "description": "Playback rate (1.0 = normal speed)"
        },
        {
          "name": "trigger",
          "type": "signal",
          "default": 1,
          "description": "Trigger to start playback from beginning"
        },
        {
          "name": "startPos",
          "type": "float",
          "default": 0,
          "description": "Starting frame position in buffer"
        },
        {
          "name": "loop",
          "type": "float",
          "default": 0,
          "description": "Loop mode (0=no loop, 1=loop)"
        },
        {
          "name": "doneAction",
          "type": "float",
          "default": 0,
          "description": "Action when playback finishes"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "play_buf_ar",
        "play_buf_kr"
      ]
    },
    {
      "name": "BufRd",
      "description": "Buffer reading oscillator. Reads values from a buffer using an index.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 1,
          "description": "Number of channels in the buffer"
        },
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to read from"
        },
        {
          "name": "phase",
          "type": "signal",
          "default": 0,
          "description": "Read position (0 to numFrames)"
        },
        {
          "name": "loop",
          "type": "float",
          "default": 1,
          "description": "Loop mode (0=no loop, 1=loop)"
        },
        {
          "name": "interpolation",
          "type": "float",
          "default": 2,
          "description": "Interpolation type (1=none, 2=linear, 4=cubic)"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "buf_rd_ar",
        "buf_rd_kr"
      ]
    },
    {
      "name": "BufWr",
      "description": "Buffer writing oscillator. Writes values to a buffer using an index.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "inputArray",
          "type": "signal",
          "default": 0,
          "description": "Signal(s) to write to buffer"
        },
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to write to"
        },
        {
          "name": "phase",
          "type": "signal",
          "default": 0,
          "description": "Write position (0 to numFrames)"
        },
        {
          "name": "loop",
          "type": "float",
          "default": 1,
          "description": "Loop mode (0=no loop, 1=loop)"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "buf_wr_ar",
        "buf_wr_kr"
      ]
    },
    {
      "name": "RecordBuf",
      "description": "Record into a buffer. Records audio into a buffer with optional looping.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "inputArray",
          "type": "signal",
          "default": 0,
          "description": "Signal(s) to record"
        },
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to record into"
        },
        {
          "name": "offset",
          "type": "float",
          "default": 0,
          "description": "Starting frame offset in buffer"
        },
        {
          "name": "recLevel",
          "type": "float",
          "default": 1,
          "description": "Recording level (0 to 1)"
        },
        {
          "name": "preLevel",
          "type": "float",
          "default": 0,
          "description": "Pre-existing content level for overdubbing"
        },
        {
          "name": "run",
          "type": "float",
          "default": 1,
          "description": "Run/pause recording (1=run, 0=pause)"
        },
        {
          "name": "loop",
          "type": "float",
          "default": 1,
          "description": "Loop mode (0=no loop, 1=loop)"
        },
        {
          "name": "trigger",
          "type": "signal",
          "default": 1,
          "description": "Trigger to start recording"
        },
        {
          "name": "doneAction",
          "type": "float",
          "default": 0,
          "description": "Action when recording finishes"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "record_buf_ar",
        "record_buf_kr"
      ]
    },
    {
      "name": "BufFrames",
      "description": "Buffer frame count. Returns the number of frames in a buffer.",
      "rates": [
        "ir",
        "kr"
      ],
      "inputs": [
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to query"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "buf_frames_kr"
      ]
    },
    {
      "name": "BufDur",
      "description": "Buffer duration. Returns the duration of a buffer in seconds.",
      "rates": [
        "ir",
        "kr"
      ],
      "inputs": [
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to query"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "buf_dur_kr"
      ]
    },
    {
      "name": "BufChannels",
      "description": "Buffer channel count. Returns the number of channels in a buffer.",
      "rates": [
        "ir",
        "kr"
      ],
      "inputs": [
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to query"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "buf_channels_kr"
      ]
    },
    {
      "name": "BufSampleRate",
      "description": "Buffer sample rate. Returns the sample rate of a buffer.",
      "rates": [
        "ir",
        "kr"
      ],
      "inputs": [
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to query"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "buf_sample_rate_kr"
      ]
    },
    {
      "name": "BufRateScale",
      "description": "Buffer rate scaling factor. Returns the ratio of buffer sample rate to server sample rate.",
      "rates": [
        "ir",
        "kr"
      ],
      "inputs": [
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to query"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "buf_rate_scale_kr"
      ]
    },
    {
      "name": "BufSamples",
      "description": "Buffer sample count. Returns the total number of samples in a buffer (frames * channels).",
      "rates": [
        "ir",
        "kr"
      ],
      "inputs": [
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to query"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "buf_samples_kr"
      ]
    },
    {
      "name": "Warp1",
      "description": "Time-stretching buffer reader. Reads from a buffer with independent control of rate and pitch.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 1,
          "description": "Number of channels in the buffer"
        },
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number to read from"
        },
        {
          "name": "pointer",
          "type": "signal",
          "default": 0,
          "description": "Position in buffer (0 to 1)"
        },
        {
          "name": "freqScale",
          "type": "float",
          "default": 1,
          "description": "Pitch/frequency scaling factor"
        },
        {
          "name": "windowSize",
          "type": "float",
          "default": 0.2,
          "description": "Window size in seconds"
        },
        {
          "name": "envbufnum",
          "type": "float",
          "default": -1,
          "description": "Envelope buffer number (-1 = default Hann)"
        },
        {
          "name": "overlaps",
          "type": "float",
          "default": 8,
          "description": "Number of overlapping windows"
        },
        {
          "name": "windowRandRatio",
          "type": "float",
          "default": 0,
          "description": "Window size randomization (0 to 1)"
        },
        {
          "name": "interp",
          "type": "float",
          "default": 1,
          "description": "Interpolation type (1=none, 2=linear, 4=cubic)"
        }
      ],
      "outputs": 1,
      "category": "Buffers",
      "functions": [
        "warp1_ar"
      ]
    }
  ],
  "Control": [
    {
      "name": "MouseX",
      "description": "Mouse horizontal position. Tracks the X position of the mouse cursor.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "minval",
          "type": "float",
          "default": 0,
          "description": "Value when mouse is at left edge"
        },
        {
          "name": "maxval",
          "type": "float",
          "default": 1,
          "description": "Value when mouse is at right edge"
        },
        {
          "name": "warp",
          "type": "float",
          "default": 0,
          "description": "Mapping curve (0=linear, 1=exponential)"
        },
        {
          "name": "lag",
          "type": "float",
          "default": 0.2,
          "description": "Lag time for smoothing in seconds"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "mouse_x_kr"
      ]
    },
    {
      "name": "MouseY",
      "description": "Mouse vertical position. Tracks the Y position of the mouse cursor.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "minval",
          "type": "float",
          "default": 0,
          "description": "Value when mouse is at bottom edge"
        },
        {
          "name": "maxval",
          "type": "float",
          "default": 1,
          "description": "Value when mouse is at top edge"
        },
        {
          "name": "warp",
          "type": "float",
          "default": 0,
          "description": "Mapping curve (0=linear, 1=exponential)"
        },
        {
          "name": "lag",
          "type": "float",
          "default": 0.2,
          "description": "Lag time for smoothing in seconds"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "mouse_y_kr"
      ]
    },
    {
      "name": "MouseButton",
      "description": "Mouse button state. Outputs 1 when button is pressed, 0 when released.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "minval",
          "type": "float",
          "default": 0,
          "description": "Value when button is up"
        },
        {
          "name": "maxval",
          "type": "float",
          "default": 1,
          "description": "Value when button is down"
        },
        {
          "name": "lag",
          "type": "float",
          "default": 0.2,
          "description": "Lag time for smoothing"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "mouse_button_kr"
      ]
    },
    {
      "name": "KeyState",
      "description": "Computer keyboard key state tracker. Outputs 1 when specified key is pressed.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "keycode",
          "type": "float",
          "default": 0,
          "description": "Key code to track"
        },
        {
          "name": "minval",
          "type": "float",
          "default": 0,
          "description": "Value when key is up"
        },
        {
          "name": "maxval",
          "type": "float",
          "default": 1,
          "description": "Value when key is down"
        },
        {
          "name": "lag",
          "type": "float",
          "default": 0.2,
          "description": "Lag time for smoothing"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "key_state_kr"
      ]
    },
    {
      "name": "Phasor",
      "description": "Resettable linear ramp between two levels. Like a sawtooth but with DC output.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger to reset phase"
        },
        {
          "name": "rate",
          "type": "float",
          "default": 1,
          "description": "Rate of change per sample/block"
        },
        {
          "name": "start",
          "type": "float",
          "default": 0,
          "description": "Start value"
        },
        {
          "name": "end",
          "type": "float",
          "default": 1,
          "description": "End value. Wraps back to start when reached"
        },
        {
          "name": "resetPos",
          "type": "float",
          "default": 0,
          "description": "Value to jump to upon reset"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "phasor_ar",
        "phasor_kr"
      ]
    },
    {
      "name": "Sweep",
      "description": "Triggered linear ramp. Ramps up from zero at a given rate when triggered.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger to reset to zero"
        },
        {
          "name": "rate",
          "type": "float",
          "default": 1,
          "description": "Rate of increase per second"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "sweep_ar",
        "sweep_kr"
      ]
    },
    {
      "name": "Select",
      "description": "Select one of many inputs. Outputs one signal from an array based on index.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "which",
          "type": "float",
          "default": 0,
          "description": "Index of signal to output (0-based, rounded)"
        },
        {
          "name": "array",
          "type": "signal",
          "default": 0,
          "description": "Array of signals to choose from"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "select_ar",
        "select_kr"
      ]
    },
    {
      "name": "SelectX",
      "description": "Crossfade between multiple inputs. Like Select but with smooth crossfading.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "which",
          "type": "float",
          "default": 0,
          "description": "Crossfade position (0 to N-1)"
        },
        {
          "name": "array",
          "type": "signal",
          "default": 0,
          "description": "Array of signals to crossfade between"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "select_x_ar",
        "select_x_kr"
      ]
    },
    {
      "name": "Timer",
      "description": "Counts time between triggers. Measures time elapsed since last trigger.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger to reset timer to zero"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "timer_ar",
        "timer_kr"
      ]
    },
    {
      "name": "LFGauss",
      "description": "Gaussian function oscillator. Generates a repeated Gaussian (bell curve) shape.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "duration",
          "type": "float",
          "default": 1,
          "description": "Duration of one Gaussian cycle in seconds"
        },
        {
          "name": "width",
          "type": "float",
          "default": 0.1,
          "description": "Width of the bell curve (smaller=narrower)"
        },
        {
          "name": "iphase",
          "type": "float",
          "default": 0,
          "description": "Initial phase (0 to 1)"
        },
        {
          "name": "loop",
          "type": "float",
          "default": 1,
          "description": "Whether to loop (1) or oneshot (0)"
        },
        {
          "name": "doneAction",
          "type": "float",
          "default": 0,
          "description": "Done action when oneshot completes"
        }
      ],
      "outputs": 1,
      "category": "Control",
      "functions": [
        "lf_gauss_ar",
        "lf_gauss_kr"
      ]
    }
  ],
  "Conversion": [
    {
      "name": "K2A",
      "description": "Control rate to audio rate converter. Converts a control rate signal to audio rate.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Control rate input signal"
        }
      ],
      "outputs": 1,
      "category": "Conversion",
      "functions": [
        "k2_a_ar"
      ]
    },
    {
      "name": "A2K",
      "description": "Audio rate to control rate converter. Decimates audio rate signal to control rate.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Audio rate input signal"
        }
      ],
      "outputs": 1,
      "category": "Conversion",
      "functions": [
        "a2_k_kr"
      ]
    },
    {
      "name": "DC",
      "description": "DC offset generator. Generates a constant signal at audio or control rate.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "float",
          "default": 0,
          "description": "Constant value to output"
        }
      ],
      "outputs": 1,
      "category": "Conversion",
      "functions": [
        "dc_ar",
        "dc_kr"
      ]
    },
    {
      "name": "T2A",
      "description": "Trigger to audio rate converter. Converts control rate triggers to audio rate impulses.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Control or audio rate trigger input"
        },
        {
          "name": "offset",
          "type": "float",
          "default": 0,
          "description": "Sample offset within the control period"
        }
      ],
      "outputs": 1,
      "category": "Conversion",
      "functions": [
        "t2_a_ar"
      ]
    },
    {
      "name": "T2K",
      "description": "Trigger to control rate converter. Converts audio rate triggers to control rate.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Audio rate trigger input"
        }
      ],
      "outputs": 1,
      "category": "Conversion",
      "functions": [
        "t2_k_kr"
      ]
    },
    {
      "name": "Silence",
      "description": "Silent audio bus. Outputs silence on a specified number of channels.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 1,
          "description": "Number of channels of silence to generate"
        }
      ],
      "outputs": 1,
      "category": "Conversion",
      "functions": [
        "silence_ar",
        "silence_kr"
      ]
    }
  ],
  "Delays": [
    {
      "name": "Delay1",
      "description": "One sample delay. Delays the input signal by exactly one sample.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "delay1_ar",
        "delay1_kr"
      ]
    },
    {
      "name": "Delay2",
      "description": "Two sample delay. Delays the input signal by exactly two samples.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "delay2_ar",
        "delay2_kr"
      ]
    },
    {
      "name": "DelayN",
      "description": "Simple delay line with no interpolation. Most efficient but can cause aliasing.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time in seconds. Sets buffer size, cannot be modulated"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds. Can be modulated"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "delay_n_ar",
        "delay_n_kr"
      ]
    },
    {
      "name": "DelayL",
      "description": "Delay line with linear interpolation. Smoother than DelayN when delay time is modulated.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time in seconds"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "delay_l_ar",
        "delay_l_kr"
      ]
    },
    {
      "name": "DelayC",
      "description": "Delay line with cubic interpolation. Highest quality, best for pitch shifting delays.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time in seconds"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "delay_c_ar",
        "delay_c_kr"
      ]
    },
    {
      "name": "CombN",
      "description": "Comb delay line with no interpolation. Creates resonances at harmonics of 1/delay time.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time in seconds"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "comb_n_ar",
        "comb_n_kr"
      ]
    },
    {
      "name": "CombL",
      "description": "Comb delay line with linear interpolation. Smoother comb filtering than CombN.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time in seconds"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "comb_l_ar",
        "comb_l_kr"
      ]
    },
    {
      "name": "CombC",
      "description": "Comb delay line with cubic interpolation. Highest quality comb filtering.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time in seconds"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "comb_c_ar",
        "comb_c_kr"
      ]
    },
    {
      "name": "AllpassN",
      "description": "All pass delay line with no interpolation. Passes all frequencies but changes phase.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time in seconds"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "allpass_n_ar",
        "allpass_n_kr"
      ]
    },
    {
      "name": "AllpassL",
      "description": "All pass delay line with linear interpolation. Smoother phase response than AllpassN.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time in seconds"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "allpass_l_ar",
        "allpass_l_kr"
      ]
    },
    {
      "name": "AllpassC",
      "description": "All pass delay line with cubic interpolation. Highest quality all pass filtering.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time in seconds"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for echoes to decay by 60dB"
        }
      ],
      "outputs": 1,
      "category": "Delays",
      "functions": [
        "allpass_c_ar",
        "allpass_c_kr"
      ]
    }
  ],
  "Demand": [
    {
      "name": "Demand",
      "description": "Demand rate UGen sequencer. Polls demand rate UGens when triggered.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger signal to demand next value"
        },
        {
          "name": "reset",
          "type": "signal",
          "default": 0,
          "description": "Resets the demand rate UGens"
        },
        {
          "name": "demandUGens",
          "type": "signal",
          "default": 0,
          "description": "Demand rate UGens to poll"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": [
        "demand_ar",
        "demand_kr"
      ]
    },
    {
      "name": "TDuty",
      "description": "Demand rate trigger generator. Generates triggers with inter-onset times from a demand UGen.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "dur",
          "type": "signal",
          "default": 1,
          "description": "Demand UGen providing duration between triggers"
        },
        {
          "name": "reset",
          "type": "signal",
          "default": 0,
          "description": "Reset signal"
        },
        {
          "name": "doneAction",
          "type": "float",
          "default": 0,
          "description": "Action when sequence completes"
        },
        {
          "name": "level",
          "type": "signal",
          "default": 1,
          "description": "Level of output trigger"
        },
        {
          "name": "gapFirst",
          "type": "float",
          "default": 0,
          "description": "If 1, waits first duration before first trigger"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": [
        "t_duty_ar",
        "t_duty_kr"
      ]
    },
    {
      "name": "Dseq",
      "description": "Demand rate sequence. Outputs values from an array in sequence.",
      "rates": [
        "demand"
      ],
      "inputs": [
        {
          "name": "array",
          "type": "signal",
          "default": 0,
          "description": "Array of values to sequence through"
        },
        {
          "name": "repeats",
          "type": "float",
          "default": 1,
          "description": "Number of times to repeat the entire sequence"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": []
    },
    {
      "name": "Dser",
      "description": "Demand rate series. Outputs values from an array, repeating each value.",
      "rates": [
        "demand"
      ],
      "inputs": [
        {
          "name": "array",
          "type": "signal",
          "default": 0,
          "description": "Array of values"
        },
        {
          "name": "repeats",
          "type": "float",
          "default": 1,
          "description": "Total number of values to output"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": []
    },
    {
      "name": "Drand",
      "description": "Demand rate random selection. Randomly selects values from an array.",
      "rates": [
        "demand"
      ],
      "inputs": [
        {
          "name": "array",
          "type": "signal",
          "default": 0,
          "description": "Array of values to choose from"
        },
        {
          "name": "repeats",
          "type": "float",
          "default": 1,
          "description": "Number of values to output"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": []
    },
    {
      "name": "Dxrand",
      "description": "Demand rate random without immediate repetition. Like Drand but never repeats the previous value.",
      "rates": [
        "demand"
      ],
      "inputs": [
        {
          "name": "array",
          "type": "signal",
          "default": 0,
          "description": "Array of values to choose from"
        },
        {
          "name": "repeats",
          "type": "float",
          "default": 1,
          "description": "Number of values to output"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": []
    },
    {
      "name": "Dseries",
      "description": "Demand rate arithmetic series. Generates start, start+step, start+2*step, etc.",
      "rates": [
        "demand"
      ],
      "inputs": [
        {
          "name": "start",
          "type": "float",
          "default": 1,
          "description": "Starting value"
        },
        {
          "name": "step",
          "type": "float",
          "default": 1,
          "description": "Step size to add each time"
        },
        {
          "name": "length",
          "type": "float",
          "default": 100000000,
          "description": "Number of values to generate"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": []
    },
    {
      "name": "Dgeom",
      "description": "Demand rate geometric series. Generates start, start*grow, start*grow^2, etc.",
      "rates": [
        "demand"
      ],
      "inputs": [
        {
          "name": "start",
          "type": "float",
          "default": 1,
          "description": "Starting value"
        },
        {
          "name": "grow",
          "type": "float",
          "default": 2,
          "description": "Multiplication factor"
        },
        {
          "name": "length",
          "type": "float",
          "default": 100000000,
          "description": "Number of values to generate"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": []
    },
    {
      "name": "Dbrown",
      "description": "Demand rate brownian motion. Random walk with specified step size bounds.",
      "rates": [
        "demand"
      ],
      "inputs": [
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum value"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Maximum value"
        },
        {
          "name": "step",
          "type": "float",
          "default": 0.01,
          "description": "Maximum step size per iteration"
        },
        {
          "name": "length",
          "type": "float",
          "default": 100000000,
          "description": "Number of values to generate"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": []
    },
    {
      "name": "Dwhite",
      "description": "Demand rate white noise. Generates random values uniformly distributed between lo and hi.",
      "rates": [
        "demand"
      ],
      "inputs": [
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum value"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Maximum value"
        },
        {
          "name": "length",
          "type": "float",
          "default": 100000000,
          "description": "Number of values to generate"
        }
      ],
      "outputs": 1,
      "category": "Demand",
      "functions": []
    }
  ],
  "Dynamics": [
    {
      "name": "Compander",
      "description": "General purpose compressor, expander, limiter, gate, ducker. Adjusts amplitude based on a control signal.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be processed"
        },
        {
          "name": "control",
          "type": "signal",
          "default": 0,
          "description": "Control signal for amplitude detection"
        },
        {
          "name": "thresh",
          "type": "float",
          "default": 0.5,
          "description": "Control signal amplitude threshold"
        },
        {
          "name": "slopeBelow",
          "type": "float",
          "default": 1,
          "description": "Slope when control < thresh. <1 = expansion, >1 = compression"
        },
        {
          "name": "slopeAbove",
          "type": "float",
          "default": 1,
          "description": "Slope when control > thresh. <1 = compression, >1 = expansion"
        },
        {
          "name": "clampTime",
          "type": "float",
          "default": 0.01,
          "description": "Attack time in seconds"
        },
        {
          "name": "relaxTime",
          "type": "float",
          "default": 0.1,
          "description": "Release time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Dynamics",
      "functions": [
        "compander_ar"
      ]
    },
    {
      "name": "Limiter",
      "description": "Peak limiter. Limits the input amplitude to a specified level with very fast attack.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Maximum allowed amplitude"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 0.01,
          "description": "Lookahead time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Dynamics",
      "functions": [
        "limiter_ar"
      ]
    },
    {
      "name": "Normalizer",
      "description": "Amplitude normalizer. Adjusts amplitude to maintain a specified level with lookahead.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Target amplitude level"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 0.01,
          "description": "Lookahead time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Dynamics",
      "functions": [
        "normalizer_ar"
      ]
    },
    {
      "name": "Amplitude",
      "description": "Amplitude follower. Tracks the amplitude envelope of a signal.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "attackTime",
          "type": "float",
          "default": 0.01,
          "description": "Attack time in seconds"
        },
        {
          "name": "releaseTime",
          "type": "float",
          "default": 0.01,
          "description": "Release time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Dynamics",
      "functions": [
        "amplitude_ar",
        "amplitude_kr"
      ]
    }
  ],
  "Envelopes": [
    {
      "name": "envelope",
      "description": "Fluent envelope builder. Creates ADSR, ASR, or percussive envelopes with an intuitive chainable API. Defaults to a constant gate of 1.0 if no gate is specified. Times can be specified as numbers (seconds) or humantime strings like \"5ms\", \"1s\", \"500ms\".",
      "rates": [
        "builder"
      ],
      "inputs": [
        {
          "name": ".attack(time)",
          "type": "method",
          "default": null,
          "description": "Set the attack time. Accepts seconds (0.01) or humantime strings (\"10ms\")."
        },
        {
          "name": ".decay(time)",
          "type": "method",
          "default": null,
          "description": "Set the decay time. Accepts seconds or humantime strings."
        },
        {
          "name": ".sustain(level)",
          "type": "method",
          "default": null,
          "description": "Set the sustain level (0.0 to 1.0). Setting this creates an ASR or ADSR envelope."
        },
        {
          "name": ".release(time)",
          "type": "method",
          "default": null,
          "description": "Set the release time. Accepts seconds or humantime strings."
        },
        {
          "name": ".perc(attack, release)",
          "type": "method",
          "default": null,
          "description": "Shorthand for percussive envelope - quick attack, natural decay. Clears sustain. Ideal for drums, plucks, piano."
        },
        {
          "name": ".asr(attack, sustain, release)",
          "type": "method",
          "default": null,
          "description": "Shorthand for attack-sustain-release envelope. Sustain is the level (0-1), not time. Ideal for pads, brass."
        },
        {
          "name": ".adsr(attack, decay, sustain, release)",
          "type": "method",
          "default": null,
          "description": "Shorthand for full ADSR envelope. Sustain is the level (0-1). Most versatile envelope shape."
        },
        {
          "name": ".triangle(duration)",
          "type": "method",
          "default": null,
          "description": "Create symmetric triangle envelope - fades in for half duration, fades out for half duration."
        },
        {
          "name": ".gate(signal)",
          "type": "method",
          "default": "dc_ar(1.0)",
          "description": "Set the gate signal that controls envelope triggering. Defaults to constant 1.0 (always on) if not specified."
        },
        {
          "name": ".time_scale(factor)",
          "type": "method",
          "default": "1.0",
          "description": "Multiply all envelope times by this factor. Use for pitch-dependent decay (lower notes decay longer) or tempo sync."
        },
        {
          "name": ".level_scale(factor)",
          "type": "method",
          "default": "1.0",
          "description": "Multiply envelope output by this factor. Useful for velocity sensitivity."
        },
        {
          "name": ".level_bias(offset)",
          "type": "method",
          "default": "0.0",
          "description": "Add DC offset to envelope output."
        },
        {
          "name": ".cleanup_on_finish()",
          "type": "method",
          "default": null,
          "description": "Free the synth when envelope completes (sets done_action=2). Essential for one-shot sounds."
        },
        {
          "name": ".done_action(value)",
          "type": "method",
          "default": "0",
          "description": "Set custom done_action. 0=none, 2=free synth. Use cleanup_on_finish() for common case."
        },
        {
          "name": ".build()",
          "type": "method",
          "default": null,
          "description": "Build and return the envelope signal. Call this at the end of the chain."
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "envelope"
      ]
    },
    {
      "name": "EnvGen",
      "description": "Low-level envelope generator. Plays back break-point envelopes specified by arrays of levels and times. For most use cases, prefer the envelope() fluent builder instead.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "gate",
          "type": "float",
          "default": 1,
          "description": "Trigger signal. When gate goes from <=0 to >0, envelope is triggered"
        },
        {
          "name": "levelScale",
          "type": "float",
          "default": 1,
          "description": "Scales all levels"
        },
        {
          "name": "levelBias",
          "type": "float",
          "default": 0,
          "description": "Offset added to all levels"
        },
        {
          "name": "timeScale",
          "type": "float",
          "default": 1,
          "description": "Scales all time values"
        },
        {
          "name": "doneAction",
          "type": "float",
          "default": 0,
          "description": "Action to perform when envelope finishes (0=none, 2=free synth)"
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "env_gen_ar",
        "env_gen_kr"
      ]
    },
    {
      "name": "Line",
      "description": "Line generator. Generates a line from start value to end value over a specified duration.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "start",
          "type": "float",
          "default": 0,
          "description": "Starting value"
        },
        {
          "name": "end",
          "type": "float",
          "default": 1,
          "description": "Ending value"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 1,
          "description": "Duration in seconds"
        },
        {
          "name": "doneAction",
          "type": "float",
          "default": 0,
          "description": "Action when line completes"
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "line_ar",
        "line_kr"
      ]
    },
    {
      "name": "XLine",
      "description": "Exponential line generator. Generates an exponential curve from start to end value.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "start",
          "type": "float",
          "default": 1,
          "description": "Starting value (must be non-zero)"
        },
        {
          "name": "end",
          "type": "float",
          "default": 2,
          "description": "Ending value (must be non-zero and same sign as start)"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 1,
          "description": "Duration in seconds"
        },
        {
          "name": "doneAction",
          "type": "float",
          "default": 0,
          "description": "Action when line completes"
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "x_line_ar",
        "x_line_kr"
      ]
    },
    {
      "name": "Lag",
      "description": "Exponential lag. Smooths a signal with exponential lag, like an RC filter.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "lagTime",
          "type": "float",
          "default": 0.1,
          "description": "60dB lag time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "lag_ar",
        "lag_kr"
      ]
    },
    {
      "name": "LagUD",
      "description": "Exponential lag with different lag times for up and down movement.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "lagTimeU",
          "type": "float",
          "default": 0.1,
          "description": "Lag time for upward movement"
        },
        {
          "name": "lagTimeD",
          "type": "float",
          "default": 0.1,
          "description": "Lag time for downward movement"
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "lag_ud_ar",
        "lag_ud_kr"
      ]
    },
    {
      "name": "VarLag",
      "description": "Variable lag with different interpolation curves. Allows for exponential, linear, or custom curves.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "time",
          "type": "float",
          "default": 0.1,
          "description": "Lag time in seconds"
        },
        {
          "name": "curvature",
          "type": "float",
          "default": 0,
          "description": "Curvature of lag. 0=linear, positive=exponential, negative=logarithmic"
        },
        {
          "name": "warp",
          "type": "float",
          "default": 5,
          "description": "Warp factor for shaping the curve"
        },
        {
          "name": "start",
          "type": "float",
          "default": 0,
          "description": "Initial value"
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "var_lag_ar",
        "var_lag_kr"
      ]
    },
    {
      "name": "Decay",
      "description": "Triggerable exponential decay. When triggered, jumps to 1 and decays to 0.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Trigger signal. Positive values trigger the decay"
        },
        {
          "name": "decayTime",
          "type": "float",
          "default": 1,
          "description": "60dB decay time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "decay_ar",
        "decay_kr"
      ]
    },
    {
      "name": "Decay2",
      "description": "Triggerable exponential attack and decay envelope. Attack goes to 1, then decays to 0.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Trigger signal"
        },
        {
          "name": "attackTime",
          "type": "float",
          "default": 0.01,
          "description": "Attack time in seconds"
        },
        {
          "name": "decayTime",
          "type": "float",
          "default": 1,
          "description": "Decay time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "decay2_ar",
        "decay2_kr"
      ]
    },
    {
      "name": "Linen",
      "description": "Simple linear attack, sustain, release envelope generator.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "gate",
          "type": "float",
          "default": 1,
          "description": "Gate signal. Envelope starts on positive transition, releases on negative"
        },
        {
          "name": "attackTime",
          "type": "float",
          "default": 0.01,
          "description": "Attack time in seconds"
        },
        {
          "name": "susLevel",
          "type": "float",
          "default": 1,
          "description": "Sustain level (0 to 1)"
        },
        {
          "name": "releaseTime",
          "type": "float",
          "default": 1,
          "description": "Release time in seconds"
        },
        {
          "name": "doneAction",
          "type": "float",
          "default": 0,
          "description": "Action when envelope completes"
        }
      ],
      "outputs": 1,
      "category": "Envelopes",
      "functions": [
        "linen_kr"
      ]
    }
  ],
  "Fft": [
    {
      "name": "FFT",
      "description": "Fast Fourier Transform. Converts time domain signal to frequency domain for spectral processing.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "buffer",
          "type": "float",
          "default": 0,
          "description": "Buffer number for FFT data"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to transform"
        },
        {
          "name": "hop",
          "type": "float",
          "default": 0.5,
          "description": "Hop size as fraction of FFT size (0.25, 0.5, or 1.0)"
        },
        {
          "name": "wintype",
          "type": "float",
          "default": 0,
          "description": "Window type (0=Sine, 1=Hann, -1=Rect)"
        },
        {
          "name": "active",
          "type": "float",
          "default": 1,
          "description": "Whether FFT is active (1=on, 0=off)"
        },
        {
          "name": "winsize",
          "type": "float",
          "default": 0,
          "description": "Window size override (0=use buffer size)"
        }
      ],
      "outputs": 1,
      "category": "FFT",
      "functions": [
        "fft_kr"
      ]
    },
    {
      "name": "IFFT",
      "description": "Inverse Fast Fourier Transform. Converts frequency domain back to time domain audio.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "buffer",
          "type": "signal",
          "default": 0,
          "description": "Buffer containing FFT data"
        },
        {
          "name": "wintype",
          "type": "float",
          "default": 0,
          "description": "Window type (0=Sine, 1=Hann, -1=Rect)"
        },
        {
          "name": "winsize",
          "type": "float",
          "default": 0,
          "description": "Window size override"
        }
      ],
      "outputs": 1,
      "category": "FFT",
      "functions": [
        "ifft_ar"
      ]
    }
  ],
  "Filters": [
    {
      "name": "LPF",
      "description": "Second order Butterworth low pass filter. Attenuates frequencies above the cutoff frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Cutoff frequency in Hertz"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "lpf_ar",
        "lpf_kr"
      ]
    },
    {
      "name": "HPF",
      "description": "Second order Butterworth high pass filter. Attenuates frequencies below the cutoff frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Cutoff frequency in Hertz"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "hpf_ar",
        "hpf_kr"
      ]
    },
    {
      "name": "BPF",
      "description": "Second order Butterworth band pass filter. Passes frequencies in a band around the center frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Center frequency in Hertz"
        },
        {
          "name": "rq",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of Q. Bandwidth / cutoff frequency"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "bpf_ar",
        "bpf_kr"
      ]
    },
    {
      "name": "BRF",
      "description": "Second order Butterworth band reject filter (notch filter). Rejects frequencies in a band around the center frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Center frequency in Hertz"
        },
        {
          "name": "rq",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of Q. Bandwidth / cutoff frequency"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "brf_ar",
        "brf_kr"
      ]
    },
    {
      "name": "RLPF",
      "description": "Resonant low pass filter. A low pass filter with resonance at the cutoff frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Cutoff frequency in Hertz"
        },
        {
          "name": "rq",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of Q. Bandwidth / cutoff frequency. Lower values = more resonance"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "rlpf_ar",
        "rlpf_kr"
      ]
    },
    {
      "name": "RHPF",
      "description": "Resonant high pass filter. A high pass filter with resonance at the cutoff frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Cutoff frequency in Hertz"
        },
        {
          "name": "rq",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of Q. Bandwidth / cutoff frequency. Lower values = more resonance"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "rhpf_ar",
        "rhpf_kr"
      ]
    },
    {
      "name": "MoogFF",
      "description": "Moog VCF style filter. A 24db/oct resonant low pass filter based on the Moog ladder filter design.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 100,
          "description": "Cutoff frequency in Hertz"
        },
        {
          "name": "gain",
          "type": "float",
          "default": 2,
          "description": "Filter resonance gain (0 to 4). Values above 1 can cause self-oscillation"
        },
        {
          "name": "reset",
          "type": "float",
          "default": 0,
          "description": "Reset the filter state when > 0"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "moog_ff_ar",
        "moog_ff_kr"
      ]
    },
    {
      "name": "Resonz",
      "description": "Resonant filter. A two pole resonant filter with constant skirt gain.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Resonant frequency in Hertz"
        },
        {
          "name": "bwr",
          "type": "float",
          "default": 1,
          "description": "Bandwidth ratio = bandwidth / cutoff frequency"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "resonz_ar",
        "resonz_kr"
      ]
    },
    {
      "name": "Formlet",
      "description": "Formant filter. A FOF-like filter with separate control over attack and decay times.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Formant frequency in Hertz"
        },
        {
          "name": "attacktime",
          "type": "float",
          "default": 1,
          "description": "Attack time in seconds (60dB)"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Decay time in seconds (60dB)"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "formlet_ar",
        "formlet_kr"
      ]
    },
    {
      "name": "Ringz",
      "description": "Ringing filter. A resonant filter with instant attack and exponential decay.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to be filtered"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Resonant frequency in Hertz"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Decay time in seconds for 60dB ring decay"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "ringz_ar",
        "ringz_kr"
      ]
    },
    {
      "name": "Integrator",
      "description": "Leaky integrator. A filter that integrates the input with a leaky factor.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "coef",
          "type": "float",
          "default": 1,
          "description": "Leak coefficient (0 to 1). 1 = perfect integration, 0 = no integration"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "integrator_ar",
        "integrator_kr"
      ]
    },
    {
      "name": "LeakDC",
      "description": "DC blocker filter. Removes DC offset from a signal using a leaky integrator.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "coef",
          "type": "float",
          "default": 0.995,
          "description": "Leak coefficient. Values closer to 1 remove more bass"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "leak_dc_ar",
        "leak_dc_kr"
      ]
    },
    {
      "name": "Median",
      "description": "Median filter. Calculates the median value in a sliding window, useful for removing impulses.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "length",
          "type": "float",
          "default": 3,
          "description": "Number of samples in the median window (must be odd)"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "median_ar",
        "median_kr"
      ]
    },
    {
      "name": "OnePole",
      "description": "One pole filter. A simple first order low pass or high pass filter.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "coef",
          "type": "float",
          "default": 0.5,
          "description": "Filter coefficient (-1 to 1). Positive = low pass, negative = high pass"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "one_pole_ar",
        "one_pole_kr"
      ]
    },
    {
      "name": "OneZero",
      "description": "One zero filter. A simple first order filter with a zero instead of a pole.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "coef",
          "type": "float",
          "default": 0.5,
          "description": "Filter coefficient (-1 to 1)"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "one_zero_ar",
        "one_zero_kr"
      ]
    },
    {
      "name": "TwoPole",
      "description": "Two pole filter. A second order resonant filter with variable frequency and radius.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Resonant frequency in Hertz"
        },
        {
          "name": "radius",
          "type": "float",
          "default": 0.8,
          "description": "Pole radius (0 to 1). Values closer to 1 = more resonance"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "two_pole_ar",
        "two_pole_kr"
      ]
    },
    {
      "name": "TwoZero",
      "description": "Two zero filter. A second order notch filter.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Notch frequency in Hertz"
        },
        {
          "name": "radius",
          "type": "float",
          "default": 0.8,
          "description": "Zero radius (0 to 1). Values closer to 1 = narrower notch"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "two_zero_ar",
        "two_zero_kr"
      ]
    },
    {
      "name": "Slew",
      "description": "Slew rate limiter. Limits the rate of change of a signal separately for up and down movement.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "up",
          "type": "float",
          "default": 1,
          "description": "Maximum upward change per second"
        },
        {
          "name": "dn",
          "type": "float",
          "default": 1,
          "description": "Maximum downward change per second"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "slew_ar",
        "slew_kr"
      ]
    },
    {
      "name": "Ramp",
      "description": "Break point linear envelope follower. Smooths a signal with a lag time like Lag but follows the input more precisely.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "lagTime",
          "type": "float",
          "default": 0.1,
          "description": "Lag time in seconds for 60dB decay"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "ramp_ar",
        "ramp_kr"
      ]
    },
    {
      "name": "Lag2",
      "description": "Second order lag. Cascaded exponential lag with two passes for smoother response.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "lagTime",
          "type": "float",
          "default": 0.1,
          "description": "Lag time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "lag2_ar",
        "lag2_kr"
      ]
    },
    {
      "name": "Lag3",
      "description": "Third order lag. Cascaded exponential lag with three passes for very smooth response.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "lagTime",
          "type": "float",
          "default": 0.1,
          "description": "Lag time in seconds"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "lag3_ar",
        "lag3_kr"
      ]
    },
    {
      "name": "FOS",
      "description": "First Order Section filter. A general purpose one-pole, one-zero filter.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "a0",
          "type": "float",
          "default": 0,
          "description": "Feedforward coefficient for current sample"
        },
        {
          "name": "a1",
          "type": "float",
          "default": 0,
          "description": "Feedforward coefficient for previous sample"
        },
        {
          "name": "b1",
          "type": "float",
          "default": 0,
          "description": "Feedback coefficient"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "fos_ar",
        "fos_kr"
      ]
    },
    {
      "name": "SOS",
      "description": "Second Order Section filter. A general purpose biquad filter (two poles, two zeros).",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "a0",
          "type": "float",
          "default": 0,
          "description": "Feedforward coefficient for current sample"
        },
        {
          "name": "a1",
          "type": "float",
          "default": 0,
          "description": "Feedforward coefficient for 1 sample ago"
        },
        {
          "name": "a2",
          "type": "float",
          "default": 0,
          "description": "Feedforward coefficient for 2 samples ago"
        },
        {
          "name": "b1",
          "type": "float",
          "default": 0,
          "description": "Feedback coefficient for 1 sample ago"
        },
        {
          "name": "b2",
          "type": "float",
          "default": 0,
          "description": "Feedback coefficient for 2 samples ago"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "sos_ar",
        "sos_kr"
      ]
    },
    {
      "name": "APF",
      "description": "All pass filter. Passes all frequencies but changes their phase relationships.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Center frequency in Hertz"
        },
        {
          "name": "radius",
          "type": "float",
          "default": 0.8,
          "description": "Radius of pole and zero (0 to 1)"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "apf_ar",
        "apf_kr"
      ]
    },
    {
      "name": "BLowPass",
      "description": "Butterworth low pass filter. Higher quality than LPF with less ripple in the pass band.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 1200,
          "description": "Cutoff frequency in Hertz"
        },
        {
          "name": "rq",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of Q (bandwidth / cutoff)"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "b_low_pass_ar",
        "b_low_pass_kr"
      ]
    },
    {
      "name": "BHiPass",
      "description": "Butterworth high pass filter. Higher quality than HPF with less ripple in the pass band.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 1200,
          "description": "Cutoff frequency in Hertz"
        },
        {
          "name": "rq",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of Q (bandwidth / cutoff)"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "b_hi_pass_ar",
        "b_hi_pass_kr"
      ]
    },
    {
      "name": "BBandPass",
      "description": "Butterworth band pass filter. High quality band pass with flat pass band response.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 1200,
          "description": "Center frequency in Hertz"
        },
        {
          "name": "bw",
          "type": "float",
          "default": 1,
          "description": "Bandwidth in octaves"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "b_band_pass_ar",
        "b_band_pass_kr"
      ]
    },
    {
      "name": "BBandStop",
      "description": "Butterworth band stop (notch) filter. High quality band reject filter.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 1200,
          "description": "Center frequency in Hertz"
        },
        {
          "name": "bw",
          "type": "float",
          "default": 1,
          "description": "Bandwidth in octaves"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "b_band_stop_ar",
        "b_band_stop_kr"
      ]
    },
    {
      "name": "BPeakEQ",
      "description": "Parametric equalizer. Boosts or cuts a frequency band around a center frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 1200,
          "description": "Center frequency in Hertz"
        },
        {
          "name": "rq",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of Q (bandwidth / cutoff)"
        },
        {
          "name": "db",
          "type": "float",
          "default": 0,
          "description": "Boost or cut in decibels. Positive = boost, negative = cut"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "b_peak_eq_ar",
        "b_peak_eq_kr"
      ]
    },
    {
      "name": "BLowShelf",
      "description": "Low shelf equalizer. Boosts or cuts all frequencies below the center frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 1200,
          "description": "Transition frequency in Hertz"
        },
        {
          "name": "rs",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of shelf slope (S)"
        },
        {
          "name": "db",
          "type": "float",
          "default": 0,
          "description": "Boost or cut in decibels"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "b_low_shelf_ar",
        "b_low_shelf_kr"
      ]
    },
    {
      "name": "BHiShelf",
      "description": "High shelf equalizer. Boosts or cuts all frequencies above the center frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 1200,
          "description": "Transition frequency in Hertz"
        },
        {
          "name": "rs",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of shelf slope (S)"
        },
        {
          "name": "db",
          "type": "float",
          "default": 0,
          "description": "Boost or cut in decibels"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "b_hi_shelf_ar",
        "b_hi_shelf_kr"
      ]
    },
    {
      "name": "BLowPass4",
      "description": "Fourth order Butterworth low pass filter. 24dB/octave rolloff for steep filtering.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 1200,
          "description": "Cutoff frequency in Hertz"
        },
        {
          "name": "rq",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of Q"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "b_low_pass4_ar",
        "b_low_pass4_kr"
      ]
    },
    {
      "name": "BHiPass4",
      "description": "Fourth order Butterworth high pass filter. 24dB/octave rolloff for steep filtering.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 1200,
          "description": "Cutoff frequency in Hertz"
        },
        {
          "name": "rq",
          "type": "float",
          "default": 1,
          "description": "Reciprocal of Q"
        }
      ],
      "outputs": 1,
      "category": "Filters",
      "functions": [
        "b_hi_pass4_ar",
        "b_hi_pass4_kr"
      ]
    }
  ],
  "Granular": [
    {
      "name": "TGrains",
      "description": "Triggered granular synthesis. Generates overlapping grains from a buffer when triggered.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 2,
          "description": "Number of output channels"
        },
        {
          "name": "trigger",
          "type": "signal",
          "default": 0,
          "description": "Trigger signal to spawn new grain"
        },
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number containing audio"
        },
        {
          "name": "rate",
          "type": "float",
          "default": 1,
          "description": "Playback rate (1.0 = normal, 2.0 = double speed)"
        },
        {
          "name": "centerPos",
          "type": "float",
          "default": 0,
          "description": "Grain center position in buffer (0 to 1)"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 0.1,
          "description": "Grain duration in seconds"
        },
        {
          "name": "pan",
          "type": "float",
          "default": 0,
          "description": "Stereo pan position (-1 to 1)"
        },
        {
          "name": "amp",
          "type": "float",
          "default": 0.1,
          "description": "Grain amplitude"
        },
        {
          "name": "interp",
          "type": "float",
          "default": 4,
          "description": "Interpolation type (1=none, 2=linear, 4=cubic)"
        }
      ],
      "outputs": 2,
      "category": "Granular",
      "functions": [
        "t_grains_ar"
      ]
    },
    {
      "name": "GrainBuf",
      "description": "Buffer-based granular synthesis. Continuously generates grains from a buffer.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 2,
          "description": "Number of output channels"
        },
        {
          "name": "trigger",
          "type": "signal",
          "default": 0,
          "description": "Trigger rate for new grains"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 1,
          "description": "Grain duration in seconds"
        },
        {
          "name": "sndbuf",
          "type": "float",
          "default": 0,
          "description": "Buffer number containing audio"
        },
        {
          "name": "rate",
          "type": "float",
          "default": 1,
          "description": "Playback rate"
        },
        {
          "name": "pos",
          "type": "float",
          "default": 0,
          "description": "Grain position in buffer (0 to 1)"
        },
        {
          "name": "interp",
          "type": "float",
          "default": 2,
          "description": "Interpolation type"
        },
        {
          "name": "pan",
          "type": "float",
          "default": 0,
          "description": "Stereo pan position"
        },
        {
          "name": "envbufnum",
          "type": "float",
          "default": -1,
          "description": "Envelope buffer number (-1 = default Hann window)"
        },
        {
          "name": "maxGrains",
          "type": "float",
          "default": 512,
          "description": "Maximum number of overlapping grains"
        }
      ],
      "outputs": 2,
      "category": "Granular",
      "functions": [
        "grain_buf_ar"
      ]
    },
    {
      "name": "GrainSin",
      "description": "Sine oscillator granular synthesis. Generates grains using sine wave oscillators.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 2,
          "description": "Number of output channels"
        },
        {
          "name": "trigger",
          "type": "signal",
          "default": 0,
          "description": "Trigger rate for new grains"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 1,
          "description": "Grain duration in seconds"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency of sine oscillator in Hz"
        },
        {
          "name": "pan",
          "type": "float",
          "default": 0,
          "description": "Stereo pan position"
        },
        {
          "name": "envbufnum",
          "type": "float",
          "default": -1,
          "description": "Envelope buffer number"
        },
        {
          "name": "maxGrains",
          "type": "float",
          "default": 512,
          "description": "Maximum number of overlapping grains"
        }
      ],
      "outputs": 2,
      "category": "Granular",
      "functions": [
        "grain_sin_ar"
      ]
    },
    {
      "name": "GrainFM",
      "description": "FM synthesis granular generator. Generates grains using FM synthesis.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 2,
          "description": "Number of output channels"
        },
        {
          "name": "trigger",
          "type": "signal",
          "default": 0,
          "description": "Trigger rate for new grains"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 1,
          "description": "Grain duration in seconds"
        },
        {
          "name": "carfreq",
          "type": "float",
          "default": 440,
          "description": "Carrier frequency in Hz"
        },
        {
          "name": "modfreq",
          "type": "float",
          "default": 200,
          "description": "Modulator frequency in Hz"
        },
        {
          "name": "index",
          "type": "float",
          "default": 1,
          "description": "FM modulation index"
        },
        {
          "name": "pan",
          "type": "float",
          "default": 0,
          "description": "Stereo pan position"
        },
        {
          "name": "envbufnum",
          "type": "float",
          "default": -1,
          "description": "Envelope buffer number"
        },
        {
          "name": "maxGrains",
          "type": "float",
          "default": 512,
          "description": "Maximum number of overlapping grains"
        }
      ],
      "outputs": 2,
      "category": "Granular",
      "functions": [
        "grain_fm_ar"
      ]
    },
    {
      "name": "GrainIn",
      "description": "Live input granular synthesis. Generates grains from a live input signal.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 2,
          "description": "Number of output channels"
        },
        {
          "name": "trigger",
          "type": "signal",
          "default": 0,
          "description": "Trigger rate for new grains"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 1,
          "description": "Grain duration in seconds"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Live input signal to granulate"
        },
        {
          "name": "pan",
          "type": "float",
          "default": 0,
          "description": "Stereo pan position"
        },
        {
          "name": "envbufnum",
          "type": "float",
          "default": -1,
          "description": "Envelope buffer number"
        },
        {
          "name": "maxGrains",
          "type": "float",
          "default": 512,
          "description": "Maximum number of overlapping grains"
        }
      ],
      "outputs": 2,
      "category": "Granular",
      "functions": [
        "grain_in_ar"
      ]
    }
  ],
  "Info": [
    {
      "name": "SampleRate",
      "description": "Server sample rate. Returns the current sample rate of the server.",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "SampleDur",
      "description": "Sample duration. Returns 1 / SampleRate (duration of one sample in seconds).",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "ControlRate",
      "description": "Server control rate. Returns the current control rate of the server.",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "ControlDur",
      "description": "Control period duration. Returns 1 / ControlRate (duration of one control block).",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "RadiansPerSample",
      "description": "Radians per sample. Returns 2π / SampleRate, useful for oscillator calculations.",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "NumOutputBuses",
      "description": "Number of output buses. Returns the number of audio output buses on the server.",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "NumInputBuses",
      "description": "Number of input buses. Returns the number of audio input buses on the server.",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "NumAudioBuses",
      "description": "Total number of audio buses. Returns the number of audio buses allocated on the server.",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "NumControlBuses",
      "description": "Number of control buses. Returns the number of control buses allocated on the server.",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "NumBuffers",
      "description": "Number of buffers. Returns the number of buffers allocated on the server.",
      "rates": [
        "ir"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": []
    },
    {
      "name": "NumRunningSynths",
      "description": "Number of running synths. Returns the current number of synths running on the server.",
      "rates": [
        "kr"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Info",
      "functions": [
        "num_running_synths_kr"
      ]
    }
  ],
  "Inout": [
    {
      "name": "In",
      "description": "Read from an audio or control bus. Reads signals from a specified bus.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "bus",
          "type": "float",
          "default": 0,
          "description": "Bus number to read from"
        },
        {
          "name": "numChannels",
          "type": "float",
          "default": 1,
          "description": "Number of channels to read"
        }
      ],
      "outputs": 1,
      "category": "InOut",
      "functions": [
        "in_ar",
        "in_kr"
      ]
    },
    {
      "name": "Out",
      "description": "Write to an audio or control bus. Writes signals to a specified bus.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "bus",
          "type": "float",
          "default": 0,
          "description": "Bus number to write to"
        },
        {
          "name": "channelsArray",
          "type": "signal",
          "default": 0,
          "description": "Signal(s) to write to the bus"
        }
      ],
      "outputs": 0,
      "category": "InOut",
      "functions": [
        "out_ar",
        "out_kr"
      ]
    },
    {
      "name": "ReplaceOut",
      "description": "Replace bus contents. Replaces instead of mixing with existing bus contents.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "bus",
          "type": "float",
          "default": 0,
          "description": "Bus number to write to"
        },
        {
          "name": "channelsArray",
          "type": "signal",
          "default": 0,
          "description": "Signal(s) to write"
        }
      ],
      "outputs": 0,
      "category": "InOut",
      "functions": [
        "replace_out_ar",
        "replace_out_kr"
      ]
    },
    {
      "name": "OffsetOut",
      "description": "Write to a bus with sample accurate timing. Like Out but with sub-sample timing precision.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "bus",
          "type": "float",
          "default": 0,
          "description": "Bus number to write to"
        },
        {
          "name": "channelsArray",
          "type": "signal",
          "default": 0,
          "description": "Signal(s) to write"
        }
      ],
      "outputs": 0,
      "category": "InOut",
      "functions": [
        "offset_out_ar"
      ]
    },
    {
      "name": "LocalIn",
      "description": "Read from the previous cycle of a local bus. Creates a feedback loop within a synth.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "numChannels",
          "type": "float",
          "default": 1,
          "description": "Number of channels"
        }
      ],
      "outputs": 1,
      "category": "InOut",
      "functions": [
        "local_in_ar",
        "local_in_kr"
      ]
    },
    {
      "name": "LocalOut",
      "description": "Write to local bus for use in the next cycle. Used with LocalIn for feedback loops.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "channelsArray",
          "type": "signal",
          "default": 0,
          "description": "Signal(s) to write to local bus"
        }
      ],
      "outputs": 0,
      "category": "InOut",
      "functions": [
        "local_out_ar",
        "local_out_kr"
      ]
    },
    {
      "name": "InFeedback",
      "description": "Read from a bus with a one block delay. Like In but reads from the previous calculation block.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "bus",
          "type": "float",
          "default": 0,
          "description": "Bus number to read from"
        },
        {
          "name": "numChannels",
          "type": "float",
          "default": 1,
          "description": "Number of channels"
        }
      ],
      "outputs": 1,
      "category": "InOut",
      "functions": [
        "in_feedback_ar"
      ]
    },
    {
      "name": "XOut",
      "description": "Crossfading bus output. Crossfades between existing bus contents and new signal.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "bus",
          "type": "float",
          "default": 0,
          "description": "Bus number to write to"
        },
        {
          "name": "xfade",
          "type": "float",
          "default": 0,
          "description": "Crossfade amount (0=leave bus unchanged, 1=replace with new signal)"
        },
        {
          "name": "channelsArray",
          "type": "signal",
          "default": 0,
          "description": "New signal(s) to crossfade in"
        }
      ],
      "outputs": 0,
      "category": "InOut",
      "functions": [
        "x_out_ar",
        "x_out_kr"
      ]
    },
    {
      "name": "SoundIn",
      "description": "Read from hardware audio input. Convenient wrapper around In for reading from sound card inputs.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "channel",
          "type": "float",
          "default": 0,
          "description": "Hardware input channel number"
        }
      ],
      "outputs": 1,
      "category": "InOut",
      "functions": [
        "sound_in_ar"
      ]
    }
  ],
  "Math": [
    {
      "name": "Clip",
      "description": "Clip signal to a range. Limits output between low and high values.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum output value"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Maximum output value"
        }
      ],
      "outputs": 1,
      "category": "Math",
      "functions": [
        "clip_ar",
        "clip_kr"
      ]
    },
    {
      "name": "Fold",
      "description": "Fold signal into a range. Values outside range are folded back into range.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum range value"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Maximum range value"
        }
      ],
      "outputs": 1,
      "category": "Math",
      "functions": [
        "fold_ar",
        "fold_kr"
      ]
    },
    {
      "name": "Wrap",
      "description": "Wrap signal into a range. Values outside range wrap around cyclically.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum range value"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Maximum range value"
        }
      ],
      "outputs": 1,
      "category": "Math",
      "functions": [
        "wrap_ar",
        "wrap_kr"
      ]
    },
    {
      "name": "MulAdd",
      "description": "Multiply and add. Efficiently computes (in * mul) + add.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "mul",
          "type": "float",
          "default": 1,
          "description": "Multiplication factor"
        },
        {
          "name": "add",
          "type": "float",
          "default": 0,
          "description": "Value to add after multiplication"
        }
      ],
      "outputs": 1,
      "category": "Math",
      "functions": [
        "mul_add_ar",
        "mul_add_kr"
      ]
    },
    {
      "name": "LinExp",
      "description": "Map linear range to exponential range. Useful for frequency mapping.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "srclo",
          "type": "float",
          "default": 0,
          "description": "Lower bound of input range"
        },
        {
          "name": "srchi",
          "type": "float",
          "default": 1,
          "description": "Upper bound of input range"
        },
        {
          "name": "dstlo",
          "type": "float",
          "default": 1,
          "description": "Lower bound of output range (must be positive)"
        },
        {
          "name": "dsthi",
          "type": "float",
          "default": 2,
          "description": "Upper bound of output range (must be positive)"
        }
      ],
      "outputs": 1,
      "category": "Math",
      "functions": [
        "lin_exp_ar",
        "lin_exp_kr"
      ]
    },
    {
      "name": "ExpLin",
      "description": "Map exponential range to linear range. Inverse of LinExp.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 1,
          "description": "Input signal"
        },
        {
          "name": "srclo",
          "type": "float",
          "default": 0.01,
          "description": "Lower bound of input range (must be positive)"
        },
        {
          "name": "srchi",
          "type": "float",
          "default": 1,
          "description": "Upper bound of input range (must be positive)"
        },
        {
          "name": "dstlo",
          "type": "float",
          "default": 0,
          "description": "Lower bound of output range"
        },
        {
          "name": "dsthi",
          "type": "float",
          "default": 1,
          "description": "Upper bound of output range"
        }
      ],
      "outputs": 1,
      "category": "Math",
      "functions": [
        "exp_lin_ar",
        "exp_lin_kr"
      ]
    },
    {
      "name": "LinLin",
      "description": "Map linear range to linear range. Simple linear scaling and offset.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "srclo",
          "type": "float",
          "default": 0,
          "description": "Lower bound of input range"
        },
        {
          "name": "srchi",
          "type": "float",
          "default": 1,
          "description": "Upper bound of input range"
        },
        {
          "name": "dstlo",
          "type": "float",
          "default": 1,
          "description": "Lower bound of output range"
        },
        {
          "name": "dsthi",
          "type": "float",
          "default": 2,
          "description": "Upper bound of output range"
        }
      ],
      "outputs": 1,
      "category": "Math",
      "functions": [
        "lin_lin_ar",
        "lin_lin_kr"
      ]
    },
    {
      "name": "ExpExp",
      "description": "Map exponential range to exponential range. Double exponential mapping.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 1,
          "description": "Input signal"
        },
        {
          "name": "srclo",
          "type": "float",
          "default": 0.01,
          "description": "Lower bound of input range (must be positive)"
        },
        {
          "name": "srchi",
          "type": "float",
          "default": 1,
          "description": "Upper bound of input range (must be positive)"
        },
        {
          "name": "dstlo",
          "type": "float",
          "default": 0.01,
          "description": "Lower bound of output range (must be positive)"
        },
        {
          "name": "dsthi",
          "type": "float",
          "default": 1,
          "description": "Upper bound of output range (must be positive)"
        }
      ],
      "outputs": 1,
      "category": "Math",
      "functions": [
        "exp_exp_ar",
        "exp_exp_kr"
      ]
    }
  ],
  "Multichannel": [
    {
      "name": "Mix",
      "description": "Mix an array of channels down to a single channel. Sums multiple inputs.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "array",
          "type": "signal",
          "default": 0,
          "description": "Array of signals to mix together"
        }
      ],
      "outputs": 1,
      "category": "Multichannel",
      "functions": [
        "mix_ar",
        "mix_kr"
      ]
    },
    {
      "name": "Splay",
      "description": "Spread an array of channels across the stereo field. Creates stereo from multiple mono sources.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "inArray",
          "type": "signal",
          "default": 0,
          "description": "Array of input signals"
        },
        {
          "name": "spread",
          "type": "float",
          "default": 1,
          "description": "Stereo spread amount (0=center, 1=full spread)"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Output level"
        },
        {
          "name": "center",
          "type": "float",
          "default": 0,
          "description": "Center position in stereo field (-1 to 1)"
        },
        {
          "name": "levelComp",
          "type": "float",
          "default": 1,
          "description": "Level compensation (1=compensate for number of channels)"
        }
      ],
      "outputs": 2,
      "category": "Multichannel",
      "functions": [
        "splay_ar",
        "splay_kr"
      ]
    }
  ],
  "Noise": [
    {
      "name": "WhiteNoise",
      "description": "White noise generator. Generates random values at full sample rate with equal distribution across all frequencies.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "white_noise_ar",
        "white_noise_kr"
      ]
    },
    {
      "name": "PinkNoise",
      "description": "Pink noise generator. Generates noise with equal energy per octave (1/f spectrum).",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "pink_noise_ar",
        "pink_noise_kr"
      ]
    },
    {
      "name": "BrownNoise",
      "description": "Brown noise generator. Generates noise with a 1/f² spectrum, also called red or Brownian noise.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "brown_noise_ar",
        "brown_noise_kr"
      ]
    },
    {
      "name": "GrayNoise",
      "description": "Gray noise generator. Generates noise that sounds equally loud at all frequencies to the human ear.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "gray_noise_ar",
        "gray_noise_kr"
      ]
    },
    {
      "name": "Dust",
      "description": "Random impulse generator. Generates random impulses from 0 to +1 at a rate determined by the density argument.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "density",
          "type": "float",
          "default": 0,
          "description": "Average number of impulses per second"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "dust_ar",
        "dust_kr"
      ]
    },
    {
      "name": "LFNoise0",
      "description": "Step noise generator. Generates random levels at a rate given by freq. Holds each value for 1/freq seconds.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 500,
          "description": "Approximate rate at which to generate random values"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "lf_noise0_ar",
        "lf_noise0_kr"
      ]
    },
    {
      "name": "LFNoise1",
      "description": "Linear interpolated noise generator. Generates random levels that are linearly interpolated.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 500,
          "description": "Approximate rate at which to generate random values"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "lf_noise1_ar",
        "lf_noise1_kr"
      ]
    },
    {
      "name": "LFNoise2",
      "description": "Quadratic noise generator. Generates random levels with quadratic interpolation between them.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 500,
          "description": "Approximate rate at which to generate random values"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "lf_noise2_ar",
        "lf_noise2_kr"
      ]
    },
    {
      "name": "Dust2",
      "description": "Bipolar random impulse generator. Generates random impulses from -1 to +1.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "density",
          "type": "float",
          "default": 0,
          "description": "Average number of impulses per second"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "dust2_ar",
        "dust2_kr"
      ]
    },
    {
      "name": "ClipNoise",
      "description": "Clip noise generator. Generates noise with only two values: -1 and +1.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "clip_noise_ar",
        "clip_noise_kr"
      ]
    },
    {
      "name": "Crackle",
      "description": "Chaotic noise generator. A noise generator based on a chaotic function with parameter control.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "chaosParam",
          "type": "float",
          "default": 1.5,
          "description": "Chaos parameter from 1.0 to 2.0. Values from 1.5 to 1.9 produce interesting sounds"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "crackle_ar",
        "crackle_kr"
      ]
    },
    {
      "name": "LFClipNoise",
      "description": "Dynamic clip noise generator. Generates noise that switches between -1 and +1 at a given frequency.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 500,
          "description": "Approximate rate at which to generate random values"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "lf_clip_noise_ar",
        "lf_clip_noise_kr"
      ]
    },
    {
      "name": "LFDNoise0",
      "description": "Dynamic step noise generator. Like LFNoise0 but can have frequency modulation.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 500,
          "description": "Approximate rate at which to generate random values"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "lfd_noise0_ar",
        "lfd_noise0_kr"
      ]
    },
    {
      "name": "LFDNoise1",
      "description": "Dynamic linear interpolated noise. Like LFNoise1 but with frequency modulation support.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 500,
          "description": "Approximate rate at which to generate random values"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "lfd_noise1_ar",
        "lfd_noise1_kr"
      ]
    },
    {
      "name": "LFDNoise3",
      "description": "Dynamic cubic interpolated noise. Generates random levels with cubic interpolation and frequency modulation support.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 500,
          "description": "Approximate rate at which to generate random values"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "lfd_noise3_ar",
        "lfd_noise3_kr"
      ]
    },
    {
      "name": "Hasher",
      "description": "Hash function random generator. Returns a number from 0 to 1 based on a hash of the input value.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to hash"
        }
      ],
      "outputs": 1,
      "category": "Noise",
      "functions": [
        "hasher_ar",
        "hasher_kr"
      ]
    }
  ],
  "Oscillators": [
    {
      "name": "SinOsc",
      "description": "Interpolating sine wave oscillator. Generates a sine wave using linear interpolation of a wavetable.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "phase",
          "type": "float",
          "default": 0,
          "description": "Phase offset or modulator in radians"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "sin_osc_ar",
        "sin_osc_kr"
      ]
    },
    {
      "name": "Saw",
      "description": "Band limited sawtooth wave oscillator. Generates a sawtooth waveform using the SuperCollider sawtooth algorithm.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "saw_ar",
        "saw_kr"
      ]
    },
    {
      "name": "Pulse",
      "description": "Band limited pulse wave oscillator with variable width. Pulse width can be modulated.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "width",
          "type": "float",
          "default": 0.5,
          "description": "Pulse width from 0 to 1. 0.5 is a square wave"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "pulse_ar",
        "pulse_kr"
      ]
    },
    {
      "name": "LFSaw",
      "description": "Low frequency sawtooth oscillator. Non-band-limited, generates aliasing at higher frequencies.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "iphase",
          "type": "float",
          "default": 0,
          "description": "Initial phase offset from 0 to 2"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "lf_saw_ar",
        "lf_saw_kr"
      ]
    },
    {
      "name": "LFPulse",
      "description": "Low frequency pulse oscillator with variable width. Non-band-limited.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "iphase",
          "type": "float",
          "default": 0,
          "description": "Initial phase offset from 0 to 1"
        },
        {
          "name": "width",
          "type": "float",
          "default": 0.5,
          "description": "Pulse width from 0 to 1"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "lf_pulse_ar",
        "lf_pulse_kr"
      ]
    },
    {
      "name": "LFTri",
      "description": "Low frequency triangle wave oscillator. Non-band-limited.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "iphase",
          "type": "float",
          "default": 0,
          "description": "Initial phase offset from 0 to 4"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "lf_tri_ar",
        "lf_tri_kr"
      ]
    },
    {
      "name": "VarSaw",
      "description": "Variable shape sawtooth oscillator. Continuously variable wave shape from sawtooth to reversed sawtooth.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "iphase",
          "type": "float",
          "default": 0,
          "description": "Initial phase offset from 0 to 1"
        },
        {
          "name": "width",
          "type": "float",
          "default": 0.5,
          "description": "Duty cycle from 0 to 1. 0.5 is a triangle wave"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "var_saw_ar",
        "var_saw_kr"
      ]
    },
    {
      "name": "Blip",
      "description": "Band limited impulse oscillator. Generates a band-limited impulse train with a specified number of harmonics.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "numharm",
          "type": "float",
          "default": 200,
          "description": "Number of harmonics"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "blip_ar",
        "blip_kr"
      ]
    },
    {
      "name": "Impulse",
      "description": "Non-band-limited single sample impulse oscillator. Generates a single sample impulse at each cycle.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "phase",
          "type": "float",
          "default": 0,
          "description": "Phase offset from 0 to 1"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "impulse_ar",
        "impulse_kr"
      ]
    },
    {
      "name": "SinOscFB",
      "description": "Sine oscillator with feedback. The feedback causes the wave to be distorted.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "feedback",
          "type": "float",
          "default": 0,
          "description": "Feedback amount from 0 to 1"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "sin_osc_fb_ar",
        "sin_osc_fb_kr"
      ]
    },
    {
      "name": "PMOsc",
      "description": "Phase modulation oscillator. Implements phase modulation synthesis with a carrier and modulator.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "carfreq",
          "type": "float",
          "default": 440,
          "description": "Carrier frequency in Hertz"
        },
        {
          "name": "modfreq",
          "type": "float",
          "default": 440,
          "description": "Modulator frequency in Hertz"
        },
        {
          "name": "pmindex",
          "type": "float",
          "default": 0,
          "description": "Phase modulation index"
        },
        {
          "name": "modphase",
          "type": "float",
          "default": 0,
          "description": "Modulator phase offset in radians"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "pm_osc_ar",
        "pm_osc_kr"
      ]
    },
    {
      "name": "FSinOsc",
      "description": "Fast sine wave oscillator. Very fast but less accurate than SinOsc.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "iphase",
          "type": "float",
          "default": 0,
          "description": "Initial phase from 0 to 2pi"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "f_sin_osc_ar",
        "f_sin_osc_kr"
      ]
    },
    {
      "name": "Triangle",
      "description": "Band-limited triangle wave oscillator.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "phase",
          "type": "float",
          "default": 0,
          "description": "Phase offset from 0 to 1"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "triangle_ar",
        "triangle_kr"
      ]
    },
    {
      "name": "LFPar",
      "description": "Low frequency parabolic wave oscillator. Generates a parabolic wave shape.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "iphase",
          "type": "float",
          "default": 0,
          "description": "Initial phase from 0 to 2"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "lf_par_ar",
        "lf_par_kr"
      ]
    },
    {
      "name": "SyncSaw",
      "description": "Hard sync sawtooth wave. A sawtooth that is reset to phase 0 when a sync signal is received.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "syncFreq",
          "type": "float",
          "default": 440,
          "description": "Frequency of the sync/reset signal in Hertz"
        },
        {
          "name": "sawFreq",
          "type": "float",
          "default": 440,
          "description": "Frequency of the sawtooth oscillator in Hertz"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "sync_saw_ar",
        "sync_saw_kr"
      ]
    },
    {
      "name": "Formant",
      "description": "Formant oscillator. Generates a set of harmonically related sine waves.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "fundfreq",
          "type": "float",
          "default": 440,
          "description": "Fundamental frequency in Hertz"
        },
        {
          "name": "formfreq",
          "type": "float",
          "default": 1760,
          "description": "Formant frequency in Hertz"
        },
        {
          "name": "bwfreq",
          "type": "float",
          "default": 880,
          "description": "Bandwidth frequency in Hertz"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "formant_ar"
      ]
    },
    {
      "name": "VOsc",
      "description": "Variable wavetable oscillator. Reads through a linear sequence of tables.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "bufpos",
          "type": "float",
          "default": 0,
          "description": "Buffer position. Position in the wavetable from 0 to numBuffers-1"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "phase",
          "type": "float",
          "default": 0,
          "description": "Phase offset from 0 to 1"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "v_osc_ar",
        "v_osc_kr"
      ]
    },
    {
      "name": "VOsc3",
      "description": "Three variable wavetable oscillators. Reads through wavetables with three separate frequencies.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "bufpos",
          "type": "float",
          "default": 0,
          "description": "Buffer position in the wavetable"
        },
        {
          "name": "freq1",
          "type": "float",
          "default": 110,
          "description": "Frequency of first oscillator in Hertz"
        },
        {
          "name": "freq2",
          "type": "float",
          "default": 220,
          "description": "Frequency of second oscillator in Hertz"
        },
        {
          "name": "freq3",
          "type": "float",
          "default": 440,
          "description": "Frequency of third oscillator in Hertz"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "v_osc3_ar",
        "v_osc3_kr"
      ]
    },
    {
      "name": "COsc",
      "description": "Chorusing wavetable oscillator. Generates two detuned wavetable oscillators.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "bufnum",
          "type": "float",
          "default": 0,
          "description": "Buffer number containing the wavetable"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Frequency in Hertz"
        },
        {
          "name": "beats",
          "type": "float",
          "default": 0.5,
          "description": "Beat frequency. Frequency offset between the two oscillators"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "c_osc_ar",
        "c_osc_kr"
      ]
    },
    {
      "name": "Klang",
      "description": "Bank of fixed sine oscillators. Generates a sum of sine waves specified by frequency, amplitude, and phase arrays.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "specificationsArrayRef",
          "type": "signal",
          "default": 0,
          "description": "Array of [frequencies, amplitudes, phases]"
        },
        {
          "name": "freqscale",
          "type": "float",
          "default": 1,
          "description": "Frequency scale multiplier"
        },
        {
          "name": "freqoffset",
          "type": "float",
          "default": 0,
          "description": "Frequency offset in Hertz"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "klang_ar"
      ]
    },
    {
      "name": "Klank",
      "description": "Bank of resonators. Excited by an input signal, generates a sum of resonating modes.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "specificationsArrayRef",
          "type": "signal",
          "default": 0,
          "description": "Array of [frequencies, amplitudes, ring times]"
        },
        {
          "name": "input",
          "type": "signal",
          "default": 0,
          "description": "Excitation input signal"
        },
        {
          "name": "freqscale",
          "type": "float",
          "default": 1,
          "description": "Frequency scale multiplier"
        },
        {
          "name": "freqoffset",
          "type": "float",
          "default": 0,
          "description": "Frequency offset in Hertz"
        },
        {
          "name": "decayscale",
          "type": "float",
          "default": 1,
          "description": "Decay time scale multiplier"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "klank_ar"
      ]
    },
    {
      "name": "Gendy1",
      "description": "Dynamic stochastic synthesis generator. Implements Iannis Xenakis' GENDYN algorithm.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "ampdist",
          "type": "float",
          "default": 1,
          "description": "Amplitude distribution: 0-6 (0=linear, 1=Cauchy, 2=logist, 3=hyperbcos, 4=arcsine, 5=expon, 6=sinus)"
        },
        {
          "name": "durdist",
          "type": "float",
          "default": 1,
          "description": "Duration distribution: 0-6 (same as ampdist)"
        },
        {
          "name": "adparam",
          "type": "float",
          "default": 1,
          "description": "Amplitude distribution parameter"
        },
        {
          "name": "ddparam",
          "type": "float",
          "default": 1,
          "description": "Duration distribution parameter"
        },
        {
          "name": "minfreq",
          "type": "float",
          "default": 440,
          "description": "Minimum frequency in Hertz"
        },
        {
          "name": "maxfreq",
          "type": "float",
          "default": 660,
          "description": "Maximum frequency in Hertz"
        },
        {
          "name": "ampscale",
          "type": "float",
          "default": 0.5,
          "description": "Amplitude scale (0 to 1)"
        },
        {
          "name": "durscale",
          "type": "float",
          "default": 0.5,
          "description": "Duration scale (0 to 1)"
        },
        {
          "name": "initCPs",
          "type": "float",
          "default": 12,
          "description": "Initial number of control points"
        },
        {
          "name": "knum",
          "type": "float",
          "default": 1,
          "description": "Current number of control points"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "gendy1_ar",
        "gendy1_kr"
      ]
    },
    {
      "name": "Gendy2",
      "description": "Dynamic stochastic synthesis generator with Lehmer random number generator.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "ampdist",
          "type": "float",
          "default": 1,
          "description": "Amplitude distribution type (0-6)"
        },
        {
          "name": "durdist",
          "type": "float",
          "default": 1,
          "description": "Duration distribution type (0-6)"
        },
        {
          "name": "adparam",
          "type": "float",
          "default": 1,
          "description": "Amplitude distribution parameter"
        },
        {
          "name": "ddparam",
          "type": "float",
          "default": 1,
          "description": "Duration distribution parameter"
        },
        {
          "name": "minfreq",
          "type": "float",
          "default": 440,
          "description": "Minimum frequency in Hertz"
        },
        {
          "name": "maxfreq",
          "type": "float",
          "default": 660,
          "description": "Maximum frequency in Hertz"
        },
        {
          "name": "ampscale",
          "type": "float",
          "default": 0.5,
          "description": "Amplitude scale (0 to 1)"
        },
        {
          "name": "durscale",
          "type": "float",
          "default": 0.5,
          "description": "Duration scale (0 to 1)"
        },
        {
          "name": "initCPs",
          "type": "float",
          "default": 12,
          "description": "Initial number of control points"
        },
        {
          "name": "knum",
          "type": "float",
          "default": 1,
          "description": "Current number of control points"
        },
        {
          "name": "a",
          "type": "float",
          "default": 1.17,
          "description": "Lehmer random generator multiplier"
        },
        {
          "name": "c",
          "type": "float",
          "default": 0.31,
          "description": "Lehmer random generator increment"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "gendy2_ar",
        "gendy2_kr"
      ]
    },
    {
      "name": "Gendy3",
      "description": "Dynamic stochastic synthesis with cubic interpolation. Smoother than Gendy1.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "ampdist",
          "type": "float",
          "default": 1,
          "description": "Amplitude distribution type (0-6)"
        },
        {
          "name": "durdist",
          "type": "float",
          "default": 1,
          "description": "Duration distribution type (0-6)"
        },
        {
          "name": "adparam",
          "type": "float",
          "default": 1,
          "description": "Amplitude distribution parameter"
        },
        {
          "name": "ddparam",
          "type": "float",
          "default": 1,
          "description": "Duration distribution parameter"
        },
        {
          "name": "freq",
          "type": "float",
          "default": 440,
          "description": "Fundamental frequency in Hertz"
        },
        {
          "name": "ampscale",
          "type": "float",
          "default": 0.5,
          "description": "Amplitude scale (0 to 1)"
        },
        {
          "name": "durscale",
          "type": "float",
          "default": 0.5,
          "description": "Duration scale (0 to 1)"
        },
        {
          "name": "initCPs",
          "type": "float",
          "default": 12,
          "description": "Initial number of control points"
        },
        {
          "name": "knum",
          "type": "float",
          "default": 1,
          "description": "Current number of control points"
        }
      ],
      "outputs": 1,
      "category": "Oscillators",
      "functions": [
        "gendy3_ar",
        "gendy3_kr"
      ]
    }
  ],
  "Panning": [
    {
      "name": "Pan2",
      "description": "Two channel equal power panner. Pans a mono signal to stereo with equal power distribution.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Mono input signal"
        },
        {
          "name": "pos",
          "type": "float",
          "default": 0,
          "description": "Pan position (-1=left, 0=center, 1=right)"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Output level"
        }
      ],
      "outputs": 2,
      "category": "Panning",
      "functions": [
        "pan2_ar",
        "pan2_kr"
      ]
    },
    {
      "name": "Balance2",
      "description": "Balance control for stereo signal. Adjusts the left/right balance of a stereo signal.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "left",
          "type": "signal",
          "default": 0,
          "description": "Left channel input"
        },
        {
          "name": "right",
          "type": "signal",
          "default": 0,
          "description": "Right channel input"
        },
        {
          "name": "pos",
          "type": "float",
          "default": 0,
          "description": "Balance position (-1=left only, 0=center, 1=right only)"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Output level"
        }
      ],
      "outputs": 2,
      "category": "Panning",
      "functions": [
        "balance2_ar",
        "balance2_kr"
      ]
    },
    {
      "name": "LinPan2",
      "description": "Two channel linear panner. Pans with linear amplitude distribution (not equal power).",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Mono input signal"
        },
        {
          "name": "pos",
          "type": "float",
          "default": 0,
          "description": "Pan position (-1=left, 0=center, 1=right)"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Output level"
        }
      ],
      "outputs": 2,
      "category": "Panning",
      "functions": [
        "lin_pan2_ar",
        "lin_pan2_kr"
      ]
    },
    {
      "name": "Pan4",
      "description": "Four channel equal power panner. Pans a signal to quad speakers.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Mono input signal"
        },
        {
          "name": "xpos",
          "type": "float",
          "default": 0,
          "description": "X position (-1 to 1, left to right)"
        },
        {
          "name": "ypos",
          "type": "float",
          "default": 0,
          "description": "Y position (-1 to 1, back to front)"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Output level"
        }
      ],
      "outputs": 4,
      "category": "Panning",
      "functions": [
        "pan4_ar",
        "pan4_kr"
      ]
    },
    {
      "name": "Rotate2",
      "description": "Rotate a stereo signal in the stereo field. Equal power rotation.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "x",
          "type": "signal",
          "default": 0,
          "description": "X input signal"
        },
        {
          "name": "y",
          "type": "signal",
          "default": 0,
          "description": "Y input signal"
        },
        {
          "name": "pos",
          "type": "float",
          "default": 0,
          "description": "Rotation position (-1 to 1)"
        }
      ],
      "outputs": 2,
      "category": "Panning",
      "functions": [
        "rotate2_ar",
        "rotate2_kr"
      ]
    },
    {
      "name": "XFade2",
      "description": "Equal power crossfade between two signals. Smooth crossfade using equal power curve.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "inA",
          "type": "signal",
          "default": 0,
          "description": "First input signal"
        },
        {
          "name": "inB",
          "type": "signal",
          "default": 0,
          "description": "Second input signal"
        },
        {
          "name": "pan",
          "type": "float",
          "default": 0,
          "description": "Crossfade position (-1=A only, 0=equal, 1=B only)"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Output level"
        }
      ],
      "outputs": 1,
      "category": "Panning",
      "functions": [
        "x_fade2_ar",
        "x_fade2_kr"
      ]
    },
    {
      "name": "LinXFade2",
      "description": "Linear crossfade between two signals. Linear amplitude crossfade.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "inA",
          "type": "signal",
          "default": 0,
          "description": "First input signal"
        },
        {
          "name": "inB",
          "type": "signal",
          "default": 0,
          "description": "Second input signal"
        },
        {
          "name": "pan",
          "type": "float",
          "default": 0,
          "description": "Crossfade position (-1=A only, 0=equal, 1=B only)"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Output level"
        }
      ],
      "outputs": 1,
      "category": "Panning",
      "functions": [
        "lin_x_fade2_ar",
        "lin_x_fade2_kr"
      ]
    },
    {
      "name": "PanAz",
      "description": "Azimuth panner for multiple speakers. Equal power panning to N speakers arranged in a circle.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "numChans",
          "type": "float",
          "default": 4,
          "description": "Number of output channels"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Mono input signal"
        },
        {
          "name": "pos",
          "type": "float",
          "default": 0,
          "description": "Pan position (0 to 1=full rotation, 0=channel 0)"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Output level"
        },
        {
          "name": "width",
          "type": "float",
          "default": 2,
          "description": "Width of panning envelope (1 to numChans)"
        },
        {
          "name": "orientation",
          "type": "float",
          "default": 0.5,
          "description": "Speaker arrangement orientation"
        }
      ],
      "outputs": 4,
      "category": "Panning",
      "functions": [
        "pan_az_ar",
        "pan_az_kr"
      ]
    },
    {
      "name": "SplayAz",
      "description": "Spread array of channels over multiple speakers in azimuth. Like Splay but for surround.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "numChans",
          "type": "float",
          "default": 4,
          "description": "Number of output channels"
        },
        {
          "name": "inArray",
          "type": "signal",
          "default": 0,
          "description": "Array of input signals"
        },
        {
          "name": "spread",
          "type": "float",
          "default": 1,
          "description": "Spread amount (0=all center, 1=full spread)"
        },
        {
          "name": "level",
          "type": "float",
          "default": 1,
          "description": "Output level"
        },
        {
          "name": "width",
          "type": "float",
          "default": 2,
          "description": "Width of panning envelope"
        },
        {
          "name": "center",
          "type": "float",
          "default": 0,
          "description": "Center position in circular space"
        },
        {
          "name": "orientation",
          "type": "float",
          "default": 0.5,
          "description": "Speaker arrangement orientation"
        },
        {
          "name": "levelComp",
          "type": "float",
          "default": 1,
          "description": "Level compensation"
        }
      ],
      "outputs": 4,
      "category": "Panning",
      "functions": [
        "splay_az_ar",
        "splay_az_kr"
      ]
    }
  ],
  "Physical": [
    {
      "name": "Pluck",
      "description": "Karplus-Strong plucked string physical model. Classic string synthesis algorithm.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Excitation signal (typically a burst of noise)"
        },
        {
          "name": "trig",
          "type": "signal",
          "default": 1,
          "description": "Trigger resets the string"
        },
        {
          "name": "maxdelaytime",
          "type": "float",
          "default": 0.2,
          "description": "Maximum delay time. Sets buffer size"
        },
        {
          "name": "delaytime",
          "type": "float",
          "default": 0.2,
          "description": "Delay time in seconds. Inversely related to pitch"
        },
        {
          "name": "decaytime",
          "type": "float",
          "default": 1,
          "description": "Time for sound to decay by 60dB"
        },
        {
          "name": "coef",
          "type": "float",
          "default": 0.5,
          "description": "Filter coefficient for the loop filter"
        }
      ],
      "outputs": 1,
      "category": "Physical",
      "functions": [
        "pluck_ar"
      ]
    },
    {
      "name": "Spring",
      "description": "Physical model of a resonating spring. Useful for metallic sounds.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Excitation/driving signal"
        },
        {
          "name": "spring",
          "type": "float",
          "default": 1,
          "description": "Spring constant"
        },
        {
          "name": "damp",
          "type": "float",
          "default": 0,
          "description": "Damping factor"
        }
      ],
      "outputs": 1,
      "category": "Physical",
      "functions": [
        "spring_ar"
      ]
    },
    {
      "name": "Ball",
      "description": "Physical model of a bouncing ball. Models a ball bouncing in a box.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Modulates the force applied to the ball"
        },
        {
          "name": "g",
          "type": "float",
          "default": 1,
          "description": "Gravity. 1.0 = standard gravity"
        },
        {
          "name": "damp",
          "type": "float",
          "default": 0,
          "description": "Damping factor (energy loss on bounce)"
        },
        {
          "name": "friction",
          "type": "float",
          "default": 0.01,
          "description": "Friction factor"
        }
      ],
      "outputs": 1,
      "category": "Physical",
      "functions": [
        "ball_ar",
        "ball_kr"
      ]
    },
    {
      "name": "TBall",
      "description": "Triggered bouncing ball physical model. Like Ball but with trigger control.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Trigger input to drop the ball"
        },
        {
          "name": "g",
          "type": "float",
          "default": 10,
          "description": "Gravity constant"
        },
        {
          "name": "damp",
          "type": "float",
          "default": 0,
          "description": "Damping factor"
        },
        {
          "name": "friction",
          "type": "float",
          "default": 0.01,
          "description": "Friction factor"
        }
      ],
      "outputs": 1,
      "category": "Physical",
      "functions": [
        "t_ball_ar",
        "t_ball_kr"
      ]
    }
  ],
  "Pitchtime": [
    {
      "name": "PitchShift",
      "description": "Time-domain pitch shifter. Changes pitch without changing duration using granular techniques.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to pitch shift"
        },
        {
          "name": "windowSize",
          "type": "float",
          "default": 0.2,
          "description": "Window size in seconds. Larger = better quality for lower pitches"
        },
        {
          "name": "pitchRatio",
          "type": "float",
          "default": 1,
          "description": "Pitch ratio. 1.0 = no shift, 2.0 = up one octave, 0.5 = down one octave"
        },
        {
          "name": "pitchDispersion",
          "type": "float",
          "default": 0,
          "description": "Amount of random pitch variation (0 to 1)"
        },
        {
          "name": "timeDispersion",
          "type": "float",
          "default": 0,
          "description": "Amount of random time variation (0 to 1)"
        }
      ],
      "outputs": 1,
      "category": "PitchTime",
      "functions": [
        "pitch_shift_ar"
      ]
    }
  ],
  "Random": [
    {
      "name": "Rand",
      "description": "Single random value generator. Generates one random value when the SynthDef is created.",
      "rates": [
        "ir"
      ],
      "inputs": [
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum value"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Maximum value"
        }
      ],
      "outputs": 1,
      "category": "Random",
      "functions": []
    },
    {
      "name": "IRand",
      "description": "Single random integer generator. Generates one random integer when the SynthDef is created.",
      "rates": [
        "ir"
      ],
      "inputs": [
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum value (inclusive)"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 127,
          "description": "Maximum value (inclusive)"
        }
      ],
      "outputs": 1,
      "category": "Random",
      "functions": []
    },
    {
      "name": "TRand",
      "description": "Triggered random value generator. Generates a new random value when triggered.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum value"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Maximum value"
        },
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger signal. Generates new value on positive transition"
        }
      ],
      "outputs": 1,
      "category": "Random",
      "functions": [
        "t_rand_ar",
        "t_rand_kr"
      ]
    },
    {
      "name": "TIRand",
      "description": "Triggered random integer generator. Generates a new random integer when triggered.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum value (inclusive)"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 127,
          "description": "Maximum value (inclusive)"
        },
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger signal"
        }
      ],
      "outputs": 1,
      "category": "Random",
      "functions": [
        "ti_rand_ar",
        "ti_rand_kr"
      ]
    },
    {
      "name": "TExpRand",
      "description": "Triggered exponential random generator. Generates exponentially distributed random values.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "lo",
          "type": "float",
          "default": 0.01,
          "description": "Minimum value (must be positive)"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Maximum value (must be positive)"
        },
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger signal"
        }
      ],
      "outputs": 1,
      "category": "Random",
      "functions": [
        "t_exp_rand_ar",
        "t_exp_rand_kr"
      ]
    },
    {
      "name": "LinRand",
      "description": "Linearly distributed random value. Skewed random distribution (init time only).",
      "rates": [
        "ir"
      ],
      "inputs": [
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Minimum value"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Maximum value"
        },
        {
          "name": "minmax",
          "type": "float",
          "default": 0,
          "description": "Skew towards min (<0) or max (>0)"
        }
      ],
      "outputs": 1,
      "category": "Random",
      "functions": []
    },
    {
      "name": "CoinGate",
      "description": "Random gate/coin toss. Randomly passes or blocks triggers based on probability.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "prob",
          "type": "float",
          "default": 0.5,
          "description": "Probability of passing trigger (0 to 1)"
        },
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Trigger input"
        }
      ],
      "outputs": 1,
      "category": "Random",
      "functions": [
        "coin_gate_ar",
        "coin_gate_kr"
      ]
    },
    {
      "name": "TWChoose",
      "description": "Triggered weighted choice from array. Randomly selects from array using probability weights.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger signal"
        },
        {
          "name": "array",
          "type": "signal",
          "default": 0,
          "description": "Array of values to choose from"
        },
        {
          "name": "weights",
          "type": "signal",
          "default": 0,
          "description": "Array of weights for each choice"
        },
        {
          "name": "normalize",
          "type": "float",
          "default": 0,
          "description": "Whether to normalize weights (1=yes, 0=no)"
        }
      ],
      "outputs": 1,
      "category": "Random",
      "functions": [
        "tw_choose_ar",
        "tw_choose_kr"
      ]
    }
  ],
  "Reverb": [
    {
      "name": "FreeVerb",
      "description": "Stereo reverb based on the Freeverb algorithm. Simple and efficient reverb effect.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Mono input signal"
        },
        {
          "name": "mix",
          "type": "float",
          "default": 0.33,
          "description": "Dry/wet mix (0=dry, 1=wet)"
        },
        {
          "name": "room",
          "type": "float",
          "default": 0.5,
          "description": "Room size (0 to 1)"
        },
        {
          "name": "damp",
          "type": "float",
          "default": 0.5,
          "description": "Damping of high frequencies (0 to 1)"
        }
      ],
      "outputs": 1,
      "category": "Reverb",
      "functions": [
        "free_verb_ar"
      ]
    },
    {
      "name": "GVerb",
      "description": "Stereo reverb with early reflections. More complex than FreeVerb with more control.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Mono input signal"
        },
        {
          "name": "roomsize",
          "type": "float",
          "default": 10,
          "description": "Room size in meters (1 to maxroomsize)"
        },
        {
          "name": "revtime",
          "type": "float",
          "default": 3,
          "description": "Reverberation time in seconds"
        },
        {
          "name": "damping",
          "type": "float",
          "default": 0.5,
          "description": "High frequency damping (0 to 1)"
        },
        {
          "name": "inputbw",
          "type": "float",
          "default": 0.5,
          "description": "Input bandwidth (0 to 1). Lower values = darker"
        },
        {
          "name": "spread",
          "type": "float",
          "default": 15,
          "description": "Stereo spread (0 to 43)"
        },
        {
          "name": "drylevel",
          "type": "float",
          "default": 1,
          "description": "Dry signal level"
        },
        {
          "name": "earlyreflevel",
          "type": "float",
          "default": 0.7,
          "description": "Early reflections level"
        },
        {
          "name": "taillevel",
          "type": "float",
          "default": 0.5,
          "description": "Reverb tail level"
        },
        {
          "name": "maxroomsize",
          "type": "float",
          "default": 300,
          "description": "Maximum room size. Sets buffer size"
        }
      ],
      "outputs": 2,
      "category": "Reverb",
      "functions": [
        "g_verb_ar"
      ]
    },
    {
      "name": "FreeVerb2",
      "description": "Stereo-in, stereo-out version of FreeVerb. Processes stereo signals.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in1",
          "type": "signal",
          "default": 0,
          "description": "Left channel input"
        },
        {
          "name": "in2",
          "type": "signal",
          "default": 0,
          "description": "Right channel input"
        },
        {
          "name": "mix",
          "type": "float",
          "default": 0.33,
          "description": "Dry/wet mix (0=dry, 1=wet)"
        },
        {
          "name": "room",
          "type": "float",
          "default": 0.5,
          "description": "Room size (0 to 1)"
        },
        {
          "name": "damp",
          "type": "float",
          "default": 0.5,
          "description": "Damping of high frequencies (0 to 1)"
        }
      ],
      "outputs": 2,
      "category": "Reverb",
      "functions": [
        "free_verb2_ar"
      ]
    },
    {
      "name": "JPverb",
      "description": "Algorithmic reverb from SC3-plugins. High quality reverb with extensive control.",
      "rates": [
        "ar"
      ],
      "inputs": [
        {
          "name": "in1",
          "type": "signal",
          "default": 0,
          "description": "Left channel input"
        },
        {
          "name": "in2",
          "type": "signal",
          "default": 0,
          "description": "Right channel input"
        },
        {
          "name": "t60",
          "type": "float",
          "default": 1,
          "description": "Approximate reverberation time in seconds"
        },
        {
          "name": "damp",
          "type": "float",
          "default": 0,
          "description": "High frequency damping (0 to 1)"
        },
        {
          "name": "size",
          "type": "float",
          "default": 1,
          "description": "Room size scale (0.5 to 5)"
        },
        {
          "name": "earlyDiff",
          "type": "float",
          "default": 0.707,
          "description": "Early reflections diffusion (0 to 1)"
        },
        {
          "name": "modDepth",
          "type": "float",
          "default": 0.1,
          "description": "Modulation depth (0 to 1)"
        },
        {
          "name": "modFreq",
          "type": "float",
          "default": 2,
          "description": "Modulation frequency in Hz"
        },
        {
          "name": "low",
          "type": "float",
          "default": 1,
          "description": "Low frequency multiplier"
        },
        {
          "name": "mid",
          "type": "float",
          "default": 1,
          "description": "Mid frequency multiplier"
        },
        {
          "name": "high",
          "type": "float",
          "default": 1,
          "description": "High frequency multiplier"
        },
        {
          "name": "lowcut",
          "type": "float",
          "default": 500,
          "description": "Low/mid crossover frequency"
        },
        {
          "name": "highcut",
          "type": "float",
          "default": 2000,
          "description": "Mid/high crossover frequency"
        }
      ],
      "outputs": 2,
      "category": "Reverb",
      "functions": [
        "j_pverb_ar"
      ]
    }
  ],
  "Triggers": [
    {
      "name": "Trig",
      "description": "Timed trigger. When triggered, outputs the trigger value for a specified duration.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Trigger input signal"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 0.1,
          "description": "Duration to hold trigger value in seconds"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "trig_ar",
        "trig_kr"
      ]
    },
    {
      "name": "Trig1",
      "description": "Timed trigger that outputs 1. When triggered, outputs 1.0 for a specified duration.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Trigger input signal"
        },
        {
          "name": "dur",
          "type": "float",
          "default": 0.1,
          "description": "Duration in seconds"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "trig1_ar",
        "trig1_kr"
      ]
    },
    {
      "name": "SendTrig",
      "description": "Send a trigger message to the client. Sends OSC message when triggered.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Trigger input signal"
        },
        {
          "name": "id",
          "type": "float",
          "default": 0,
          "description": "Trigger ID number"
        },
        {
          "name": "value",
          "type": "float",
          "default": 0,
          "description": "Value to send with trigger message"
        }
      ],
      "outputs": 0,
      "category": "Triggers",
      "functions": [
        "send_trig_ar",
        "send_trig_kr"
      ]
    },
    {
      "name": "SendReply",
      "description": "Send an array of values to the client. Like SendTrig but can send multiple values.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger input signal"
        },
        {
          "name": "cmdName",
          "type": "float",
          "default": 0,
          "description": "Command name identifier"
        },
        {
          "name": "values",
          "type": "signal",
          "default": 0,
          "description": "Array of values to send"
        },
        {
          "name": "replyID",
          "type": "float",
          "default": -1,
          "description": "Reply ID number"
        }
      ],
      "outputs": 0,
      "category": "Triggers",
      "functions": [
        "send_reply_ar",
        "send_reply_kr"
      ]
    },
    {
      "name": "Latch",
      "description": "Sample and hold. Samples the input value when triggered and holds it.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to sample"
        },
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger signal"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "latch_ar",
        "latch_kr"
      ]
    },
    {
      "name": "Gate",
      "description": "Gate signal pass through. Passes input when gate is positive, holds last value when negative.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Gate signal (positive = pass, negative/zero = hold)"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "gate_ar",
        "gate_kr"
      ]
    },
    {
      "name": "PulseDivider",
      "description": "Pulse divider. Outputs a trigger every Nth input trigger.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger input"
        },
        {
          "name": "div",
          "type": "float",
          "default": 2,
          "description": "Division factor (outputs every Nth trigger)"
        },
        {
          "name": "start",
          "type": "float",
          "default": 0,
          "description": "Starting count value"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "pulse_divider_ar",
        "pulse_divider_kr"
      ]
    },
    {
      "name": "PulseCount",
      "description": "Pulse counter. Counts triggers and outputs the count.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger input to count"
        },
        {
          "name": "reset",
          "type": "signal",
          "default": 0,
          "description": "Reset counter to zero"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "pulse_count_ar",
        "pulse_count_kr"
      ]
    },
    {
      "name": "Peak",
      "description": "Track peak signal value. Outputs the maximum value seen since last reset.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Reset trigger"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "peak_ar",
        "peak_kr"
      ]
    },
    {
      "name": "Schmidt",
      "description": "Schmitt trigger. Outputs 1 when input > hi, 0 when input < lo (hysteresis).",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal"
        },
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Lower threshold"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Upper threshold"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "schmidt_ar",
        "schmidt_kr"
      ]
    },
    {
      "name": "SetResetFF",
      "description": "Set-reset flip flop. Set input sets output to 1, reset input sets output to 0.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Set trigger (sets output to 1)"
        },
        {
          "name": "reset",
          "type": "signal",
          "default": 0,
          "description": "Reset trigger (sets output to 0)"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "set_reset_ff_ar",
        "set_reset_ff_kr"
      ]
    },
    {
      "name": "ToggleFF",
      "description": "Toggle flip flop. Each trigger toggles the output between 0 and 1.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger input to toggle state"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "toggle_ff_ar",
        "toggle_ff_kr"
      ]
    },
    {
      "name": "Stepper",
      "description": "Step through values. Counts up/down through a range with trigger and reset.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "trig",
          "type": "signal",
          "default": 0,
          "description": "Trigger to advance one step"
        },
        {
          "name": "reset",
          "type": "signal",
          "default": 0,
          "description": "Reset to resetval"
        },
        {
          "name": "min",
          "type": "float",
          "default": 0,
          "description": "Minimum value"
        },
        {
          "name": "max",
          "type": "float",
          "default": 7,
          "description": "Maximum value"
        },
        {
          "name": "step",
          "type": "float",
          "default": 1,
          "description": "Step size (can be negative)"
        },
        {
          "name": "resetval",
          "type": "float",
          "default": 0,
          "description": "Value to reset to"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "stepper_ar",
        "stepper_kr"
      ]
    },
    {
      "name": "TrigControl",
      "description": "Trigger rate control input. Used for control-rate trigger inputs in SynthDefs.",
      "rates": [
        "kr"
      ],
      "inputs": [],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "trig_control_kr"
      ]
    },
    {
      "name": "InRange",
      "description": "Test if signal is within range. Outputs 1 if lo <= in <= hi, otherwise 0.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to test"
        },
        {
          "name": "lo",
          "type": "float",
          "default": 0,
          "description": "Lower bound (inclusive)"
        },
        {
          "name": "hi",
          "type": "float",
          "default": 1,
          "description": "Upper bound (inclusive)"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "in_range_ar",
        "in_range_kr"
      ]
    },
    {
      "name": "InRect",
      "description": "Test if point is within rectangle. Outputs 1 if (x,y) is inside rectangle.",
      "rates": [
        "ar",
        "kr",
        "ir"
      ],
      "inputs": [
        {
          "name": "x",
          "type": "signal",
          "default": 0,
          "description": "X coordinate"
        },
        {
          "name": "y",
          "type": "signal",
          "default": 0,
          "description": "Y coordinate"
        },
        {
          "name": "rect",
          "type": "signal",
          "default": 0,
          "description": "Rectangle bounds [left, top, right, bottom]"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "in_rect_ar",
        "in_rect_kr"
      ]
    },
    {
      "name": "Changed",
      "description": "Trigger when input changes. Outputs a trigger when the input value changes.",
      "rates": [
        "ar",
        "kr"
      ],
      "inputs": [
        {
          "name": "in",
          "type": "signal",
          "default": 0,
          "description": "Input signal to monitor"
        },
        {
          "name": "threshold",
          "type": "float",
          "default": 0,
          "description": "Minimum change to trigger (0 = any change)"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "changed_ar",
        "changed_kr"
      ]
    },
    {
      "name": "Done",
      "description": "Detect when a UGen has finished. Outputs a trigger when the input finishes.",
      "rates": [
        "kr"
      ],
      "inputs": [
        {
          "name": "src",
          "type": "signal",
          "default": 0,
          "description": "UGen to monitor for done signal"
        }
      ],
      "outputs": 1,
      "category": "Triggers",
      "functions": [
        "done_kr"
      ]
    }
  ]
};

export function UGenDocs({ searchTerm = '', selectedCategory = 'all', expandedItem, onCardToggle }) {
  // When searching, always search all categories
  const filteredCategories = (searchTerm || selectedCategory === 'all')
    ? ugenCategories
    : ugenCategories.filter(c => c === selectedCategory);

  return (
    <div className="ugen-docs">
      {filteredCategories.map(category => {
        const ugens = ugenData[category].filter(ugen => {
          if (!searchTerm) return true;
          const term = searchTerm.toLowerCase();
          return ugen.name.toLowerCase().includes(term) ||
                 ugen.description.toLowerCase().includes(term);
        });

        if (ugens.length === 0) return null;

        return (
          <div key={category} className="ugen-category">
            <h3 className="ugen-category__title">{category}</h3>
            <div className="ugen-category__list">
              {ugens.map(ugen => (
                <UGenCard
                  key={ugen.name}
                  ugen={ugen}
                  isExpanded={expandedItem === ugen.name}
                  onToggle={() => onCardToggle(ugen.name)}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function UGenCard({ ugen, isExpanded, onToggle }) {
  return (
    <div className={`ugen-card ${isExpanded ? 'ugen-card--expanded' : ''}`} data-item-name={ugen.name}>
      <div className="ugen-card__header" onClick={onToggle}>
        <div className="ugen-card__title-row">
          <span className="ugen-card__name">{ugen.name}</span>
          <span className="ugen-card__rates">
            {ugen.rates.map(r => (
              <span key={r} className={`ugen-card__rate ugen-card__rate--${r}`}>{r}</span>
            ))}
          </span>
        </div>
        <p className="ugen-card__description">{ugen.description}</p>
        <span className="ugen-card__expand-icon">{isExpanded ? '−' : '+'}</span>
      </div>

      {isExpanded && (
        <div className="ugen-card__details">
          {ugen.inputs && ugen.inputs.length > 0 ? (
            <table className="ugen-card__params">
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {ugen.inputs.map(input => (
                  <tr key={input.name}>
                    <td className="ugen-card__param-name">{input.name}</td>
                    <td className="ugen-card__param-type">{input.type}</td>
                    <td className="ugen-card__param-default">{input.default}</td>
                    <td className="ugen-card__param-desc">{input.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="ugen-card__no-params">No parameters - this UGen has no configurable inputs.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default UGenDocs;
